import { takeLatest, put, call, select } from "redux-saga/effects";

import { change, initialize } from "redux-form";
import axios from "axios";
import MyDocument from '../exportpdf/mydocument';
import { pdf } from '@react-pdf/renderer';
import moment from 'moment'
import XlsxPopulate from "xlsx-populate";
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";

import React from "react";

import {
  INCREASE_STEP,
  LOAD_CATALOG,
  REDUX_BLUR,
  HEADERS_WS,
  REDUX_CHANGE,
  VALIDA_AFILIACION_COMPANY,
  GESTION_PERSONAL_ADMIN,
  CREATE_DIRECCION_MODAL,
  FORM_NAME_STEP2,
  FORM_NAME_STEP3,
  FORM_NAME_STEP1,
  FORM_NAME_STEP4,
  REQUIRED_FORM_STEP1,
  REQUIRED_FORM_STEP2,
  REQUIRED_FORM_STEP3,
  REQUIRED_FORM_STEP4,
  REQUIRED_FORM_PRINCIPAL,

  UPLOAD_ANEXOS,
  REMOVE_ANEXOS,
  SEE_ANEXOS,
  VALIDATE_NUM_PROCESS,
  REQUIRED_FORM_STEP0,
  FORM_NAME_STEP0,
  SALVAR_STEP,
  FORM_NAME_STEP_PRINCIPAL,
  FORM_NAME_DIRECCION,
  REQUIRED_FORM_STEP2_DOMES,
  OPEN_VALIDATE_ANEXOS,
  INIT_CATALOG_COMPLETED,
  VEFICATED_CHANGES_FROM_BANDEJA,
  HANDLE_STEP,
  REQUIRED_FORM_STEP3_ALTERN,
  DELETE_CONTACTO_EXISTS_STEP4,
  DOWNLOAD_RELATION_WORKERS,
  REQUIRED_DATOS_DIRECCION,
} from './constants';

import {
  loadCatalogSuccess,
  loadDocumentSuccess,
  base64Remove,
  increaseSiguiente,
  estadoAfiliacionCompany,
  savedCatalogCompany,
  saveIdFormulario,
  saveIdUser,
  modalInformacionFlujos,
  saveAnexos,
  popupSEEAnexos,
  openModalNumProcess,
  saveDataTablePersonal,
  openModalCharged,
  saveRefeFiles,
  dataPantallaInicio,
  formularioType,
  callDinamicDisable,
  callDinamicDisableLote,
  chargeAnexosStorage,
  savedEmpleadorType,
  limitStep,
  closeFinalModal,
  savedSolicitudes,
  openFinalModal,
  saveReferenceBarcode,
  cleanAutoComplete,
  changeCorregimientoForm,
  openModalFormularioRegistro,
  devueltaModificacionActive,
  savedTamanioFiles,
  savedIdApp,
  uploadAnexosSaga,
  saveUserComercial,
  chagesFromBandeja,
  savePersonalAdmin,
  openModalAcceptPDF,
  verMotivoDevolucion,
  createUserPerson,
  saveSolicitudesSinFirma,
  errorGeneral,
  updateMsgSolicitud,
  editingEnabledContact,
  validRnecRepLegal,
  initEditarFromBandeja,
  saveDatosCedulasRnec,
  changeComponentId,
  deleteContactsFromValidationStep4,
  activateSoportRnec,
  closeDireccionModalSuccess,
  saveMapeoRuesSuccess,
} from './actions';

import {
  fullFormSelector,
  getCatalogosCargados,
  getbase64Add,
  getFormValuesDireccion,
  getNameCampoDire,
  getIdFormulario,
  getIdUser,
  getFormValuesStepPricipal,
  getFormValuesStep4,
  getActiveStep,
  getTableDataPersonal,
  getFormValuesModalIdForm,
  getRefeFiles,
  getDataPantallaInicio,
  getFormValuesStep1,
  getEmpleadorType,
  getActiveFormRya,
  getFormularioCustomer,
  getSolicitudes,
  getReferenceBarcode,
  getUserInfoComercial,
  getFormValuesStep0,
  getDynamicOptions,
  getFormDevuelto,
  getEstadoAfiliacionCompany,
  getIdAppForm,
  getFormValuesStep2,
  getTamanioFiles,
  getPersonalAdmin,
  getUserPersona,
  getBase64Start,
  getSolicitudesSinfirma,
  getBase64pdfSinFirma,
  getMsgParametrizados,
  getEditEnabled,
  getDatosConsultaRnec,
  getSoportRnec,
  getDataRues,
} from "./selectors";

import { firebaseDatabase, firebaseStorage } from "../../controller/firebase";
import { logout, saveInSession } from "../../controller/session";
import { emptyObject, getAsyncCatalog, getBase64, onlyUniqueLabel, saveHistoryEmpresas, fontSizeCortar, returnDataCatalog, getAsyncConfiguration, existLabel, primeraMayuscula, emptyJson, notificaFalloWBS, createNotaOportunidad, enviarEmailFormatDocument, conversion, generaMacrosector, getFechaOfDateV2, getFechaOfDateV3, validarCambios, manejoDeexepciones, consultaMsgParametrizado, sleep, cortarMSM, saveBdWebService, getCodeOfDateSystem, filterDataRnec, getFechaOfDateRya, generatePDFbUtil, returnDataCatalogV2, cleanRazonSocial, validPhoneRues } from "../../controller/utils";
import { estados } from "../../controller/constants";
import { isEmpty } from "lodash";
import { ref, uploadBytes } from "firebase/storage";
import MyDocumentRelacion from "../exportpdf/relacionTrabajadores";


function* iniFormFromBandeja(action) {
  /* Cuando el formulario se carga desde la bandeja de comercial o la bandeja de RyA
      Se hace una consulta del formulario en cuestion y se procede a cargar la informacion en cada campo
   */
  const { params } = action;

  try {
    let solicitudes = false;
    yield put(saveIdFormulario(params));

    yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
      .doc(params)
      .get().then(docs => {
        if (docs.data()) {
          solicitudes = docs.data();
        }

      }).catch((err) => {
        console.error(err)
      });
    if (solicitudes) {
      yield put(savedSolicitudes({ ...solicitudes }));
      yield initAllForms({ value: solicitudes });
      yield put(estadoAfiliacionCompany(true));

      if (solicitudes.step4.datosrepresentante && solicitudes.step4.datosrepresentante["rnecBox"]) {
        yield put(validRnecRepLegal(true));
      }
    }
  } catch (error) {
    console.error("Exception:", error)
    throw error;
  }
}

function* initAllForms(action) {
  /* Funcion que se encarga de precargar la informacion ya registrada en cada step,
     Sucede si es la primera ves que se crea la postulacion o si se retoma una ya creada
   */
  const { value } = action;
  try {

    yield put(openModalCharged(true));
    // let idUser = select(getIdUser);

    if (value) {
      let step0 = value['step0'] ? value['step0'] : {};
      let step1 = value['step1'] ? value['step1'] : {};
      let step2 = value['step2'] ? value['step2'] : {};
      let step3 = value['step3'] ? value['step3'] : {};
      let step4 = value['step4'] ? value['step4'] : {};
      let refeBarcode = value['refeBarcode'] ? value['refeBarcode'] : "";
      let stepPrincipal = value['stepPrincipal'] ? value['stepPrincipal'] : {};
      let refeFiles = value['refeFiles'] ? value['refeFiles'] : [];
      let idOportunidad = value['idOportunidad'] ? value['idOportunidad'] : false;
      let asesorAsigna = value['asesorAsigna'] ? value['asesorAsigna'] : false;
      let userComercial = value['asistido'] ? value['asistido'] : {};
      let dataRnec = value['dataRnec'] ? value['dataRnec'] : { representante: false, contacto: [] };
      let soportRnec = value['soportRnec'] ? value['soportRnec'] : false;

      yield put(saveDatosCedulasRnec(dataRnec));
      yield put(activateSoportRnec(soportRnec));

      if (step0 && step0.datosinicio) {
        yield put(createUserPerson({
          id: step0.datosinicio.checkNumberStart,
          tipoId: step0.datosinicio.typeIdCompanyStart,
          rol: "Empresa",
          email: step0.datosinicio.emailCompanyStart,
          nameCompleted: step0.datosinicio.employerNameStart
        }))
      }
      if (!emptyJson(userComercial))
        yield put(saveUserComercial(userComercial))

      yield put(savedIdApp({ idOportunidad, asesorAsigna }));
      yield put(saveReferenceBarcode(refeBarcode));
      const catalogo = yield select(getCatalogosCargados);

      if (stepPrincipal && stepPrincipal.afiliacionEmpresas) {
        yield put(savedEmpleadorType(stepPrincipal.afiliacionEmpresas?.empleadorTypeCompany))
        yield put(dataPantallaInicio(stepPrincipal));

        //valores por defecto de clase de empresa y bloqueo de campos
        if (stepPrincipal.afiliacionEmpresas.empleadorTypeCompany === "3" && stepPrincipal?.afiliacionEmpresas?.typeIdCompanyGes === "CC") {
          yield put(callDinamicDisable({ field: "companyClass", state: true }));
        }

        // if (stepPrincipal.afiliacionEmpresas.empleadorTypeCompany === "1" ) {
        //   yield put(callDinamicDisable({ field: "companyClass", state: false }));
        // }


        if (stepPrincipal.afiliacionEmpresas.empleadorTypeCompany === "3") {

          yield put(limitStep(4))
          yield put(callDinamicDisable({ field: "economicActivityStart", state: true }));
        } else {
          yield put(limitStep(5))
        }


        yield dowloadCatalogAnexos({ items: stepPrincipal.afiliacionEmpresas })

      }

      if (step1 && step1.datospersonaladmin?.length > 0) {
        // 
        let newData = {
          disable: false,
          options: [],
          field: "tablePersonal",
        };

        step1.datospersonaladmin.forEach(element => {
          newData.options.push(
            [
              { rnec: emptyObject(element?.rnec) },
              { label: emptyObject(element?.typeIdStaff) },
              { label: emptyObject(element?.numberIdStaff) },
              { label: emptyObject(element?.firstLastnameStaff) },
              { label: emptyObject(element?.secondLastnameStaff) },
              { label: emptyObject(element?.firstNameStaff) },
              { label: emptyObject(element?.secondNameStaff) },
              { label: emptyObject(element?.jobBossStaff) },
              { label: emptyObject(element?.emailStaff) },
            ]
          )
        });
        yield put(saveDataTablePersonal(step1.datospersonaladmin));
        yield put(loadDocumentSuccess(newData));

      }
      if (step0 && step0.datosinicio) {

        var newData = {};

        newData = {
          disable: false,
          options: catalogo.typeId,
          field: "typeIdCompanyStart",
        };

        if (stepPrincipal.afiliacionEmpresas.empleadorTypeCompany === "1") {
          newData.options = [{ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" }];
        }

        yield put(loadDocumentSuccess(newData));
      }


      if (step2 && step2.datosempleador) {

        var newData = {};

        newData = {
          disable: false,
          options: catalogo.typeId,
          field: "typeIdCompany",
        };

        if (stepPrincipal.afiliacionEmpresas.empleadorTypeCompany === "1") {
          newData.options = [{ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" }];
        }

        yield put(loadDocumentSuccess(newData));

        if (step2.datosempleador.contributionPeriod)
          step2.datosempleador.contributionPeriod = (step2.datosempleador.contributionPeriod).toDate();

        if (step2.datosempleador.startOperation)
          step2.datosempleador.startOperation = (step2.datosempleador.startOperation).toDate();

      }

      if (step3 && step3.ubicacionempleador) {
        var newData = {};

        const depa1 = idDeparta(catalogo.deptos, step3.ubicacionempleador?.departamentCompany);
        var cities1 = crearCities(catalogo.cities, depa1);
        newData = {
          disable: false,
          options: cities1.sort(ordenar),
          field: "cityCompany",
        };
        yield put(loadDocumentSuccess(newData));

        const city = idDeparta(catalogo.cities, step3.ubicacionempleador?.cityCompany)
        var barrios = crearBarrios(catalogo.barrios, city);
        newData = {
          disable: false,
          options: barrios.sort(ordenar),
          field: "hoodCompany",
        };
        yield put(loadDocumentSuccess(newData));

        const depa2 = idDeparta(catalogo.deptos, step3.ubicacionempleadoraltern?.departamentCompanyAlternate);
        var citiesP = crearCities(catalogo.cities, depa2);
        newData = {
          disable: false,
          options: citiesP.sort(ordenar),
          field: "cityCompanyAlternate",
        };
        yield put(loadDocumentSuccess(newData));

        const cityA = idDeparta(catalogo.cities, step3.ubicacionempleadoraltern?.cityCompanyAlternate)
        var barriosA = crearBarrios(catalogo.barrios, cityA);
        newData = {
          disable: false,
          options: barriosA.sort(ordenar),
          field: "hoodCompanyAlternate",
        };
        yield put(loadDocumentSuccess(newData));

      }

      if (step4 && step4.datosrepresentante) {

        if (step4.datosrepresentante["rnecBox"]) {
          yield put(validRnecRepLegal(true));
        }

        if (step4.datosrepresentante.birthDate)
          step4.datosrepresentante.birthDate = (step4.datosrepresentante.birthDate).toDate();

        var newData = {};

        newData = {
          disable: false,
          options: catalogo.typeId,
          field: "typeId",
        };

        yield put(loadDocumentSuccess(newData));

        //Cambiar componente por tipo de identificacion
        if (step4.datosrepresentante.typeId === "PA" || step4.datosrepresentante.typeId === "PT" || step4.datosrepresentante.typeId === "PE")
          yield put(changeComponentId({ field: "numberId", type: "text" }));
        else
          yield put(changeComponentId({ field: "numberId", type: "number" }));

      }

      //desactivar Info replegal
      let loteDisa = [
        { field: "birthDate", state: false },
        { field: "firstLastname", state: false },
        { field: "secondLastname", state: false },
        { field: "firstName", state: false },
        { field: "secondName", state: false },
        { field: "sexo", state: false },
        { field: "smartPhoneBoss", state: false },
        { field: "emailJobBoss", state: false }

      ];

      loteDisa.forEach(e => {
        if (step4.datosrepresentante && step4.datosrepresentante[e.field] && step4.datosrepresentante[e.field].length > 0) {
          e.state = true;
        }
      });

      if (stepPrincipal.afiliacionEmpresas.empleadorTypeCompany !== "1") {
        loteDisa.push({ field: "typeId", state: true })
        loteDisa.push({ field: "numberId", state: true })
      }

      yield put(callDinamicDisableLote(loteDisa));
      ////////////////////////////////

      yield put(initialize(FORM_NAME_STEP0, step0));
      yield put(initialize(FORM_NAME_STEP2, step2));
      yield put(initialize(FORM_NAME_STEP3, step3));
      yield put(initialize(FORM_NAME_STEP4, step4));

      if (refeFiles.length > 0) {
        //hay adjuntos y se ban a descargar su base64
        yield put(saveRefeFiles(refeFiles));
        yield bajarFiles(refeFiles);
      }

      yield put(openModalCharged(false));
    }


  } catch (error) {
    console.error("Function.initAllForms", error);
    throw error;
  }
}

function calcularDigitoVerificacion(myNit) {
  /* Funcion que se encarga de calcular el digito de verificación a partir de un numero de identificación
   */
  var vpri,
    x,
    y,
    z;

  // Se limpia el Nit
  myNit = myNit.replace(/\s/g, ""); // Espacios
  myNit = myNit.replace(/,/g, ""); // Comas
  myNit = myNit.replace(/\./g, ""); // Puntos
  myNit = myNit.replace(/-/g, ""); // Guiones

  // Se valida el nit
  if (isNaN(myNit)) {

    return "";
  };

  // Procedimiento
  vpri = new Array(16);
  z = myNit.length;

  vpri[1] = 3;
  vpri[2] = 7;
  vpri[3] = 13;
  vpri[4] = 17;
  vpri[5] = 19;
  vpri[6] = 23;
  vpri[7] = 29;
  vpri[8] = 37;
  vpri[9] = 41;
  vpri[10] = 43;
  vpri[11] = 47;
  vpri[12] = 53;
  vpri[13] = 59;
  vpri[14] = 67;
  vpri[15] = 71;

  x = 0;
  y = 0;
  for (var i = 0; i < z; i++) {
    y = (myNit.substr(i, 1));

    x += (y * vpri[z - i]);
  }

  y = x % 11;

  return (y > 1) ? 11 - y : y;
}

function* consumeValidadorSirap(action) {
  /* Función que recibe el documento y tipo de documento del afiliado
      y consulta el validador de derechos y retorna la información del afiliado
   */

  const { id, tipo } = action;
  var date = "";
  var date = new Date();

  const urlConfenalco = process.env.REACT_APP_URL_COMFENALCO_ENDPOINT;
  const body = {

    "requestMessageOut": {
      "header": {
        "systemId": "FORMULARIOSWEB",
        "invokerDateTime": date,
        "destination": {
          "namespace": "http://co/com/comfenalcovalle/esb/ws/HCPConsultaInformacionAfiliado",
          "name": "HCPConsultaInformacionAfiliado",
          "operation": "execute"
        },
        "messageId": tipo + "|" + id,
        "securityCredential": {
          "userToken": "",
          "userName": ""
        },
        "moduleId": "AFILIACIONSIRAP",
        "logginData": {
          "sourceSystemId": "",
          "destinationSystemId": ""
        },
        "classification": {
          "classification": ""
        }
      },
      "body": {
        "request": {
          "consultarAfiliadoSirap": {
            "tipoDocumento": tipo,
            "numeroDocumento": id,
          }
        }
      }
    }

  }

  var resul = false;
  try {
    const res = yield consumeServiceGenerico({ body, url: urlConfenalco })
    console.log(res);
    if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS") {
      resul = res.responseMessageOut.body.response.informacionAfiliadoResponse.consultaAfiliadoSirap ? res.responseMessageOut.body.response.informacionAfiliadoResponse.consultaAfiliadoSirap : false;
    }

    return resul;
  } catch (error) {
    throw `Function.consumeValidadorSirap - saga.js -${error}`;
    throw error;
  }
}

function* consumeWsValidadorRues(action) {
  /* Función que recibe el documento y tipo de documento del afiliado
      y consulta el validador de derechos y retorna la información del afiliado
   */

  const { id, tipoId } = action;
  // console.log("entr00000")
  const urlConfenalco = process.env.REACT_APP_URL_CONSULTA_RUES
  const body = { id, tipoId }

  try {

    const headers = HEADERS_WS;
    const respues = yield call(axios.post, urlConfenalco, body, headers);
    return respues;
  } catch (error) {
    throw `Function.consumeValidadorSirap - saga.js -${error}`;
    throw error;
  }
}

function* consumeMapeoRues(action) {
  /* Función que recibe el documento y tipo de documento del afiliado
      y consulta el validador de derechos y retorna la información del afiliado
   */

  const { id, tipoId, typeEmpleador } = action;
  //{ id: "830075303", tipoId: "02" }
  let idRues = [
    { h: "01", S: "CC" },
    { h: "02", S: "NI" },
    { h: "03", S: "CE" },
    { h: "04", S: "TI" },
    { h: "05", S: "PA" },
    { h: "07", S: "RC" },
    { h: "08", S: "DE" },
    { h: "09", S: "PPE" }
  ]
  let respLegal = false;
  const idR = idRues.find(i => i.S === tipoId)
  let items = false
  try {

    const rues = yield consumeWsValidadorRues({ id, tipoId: idR.h });
    console.log(action, idR, rues, tipoId)
    if (rues && rues.data.body && rues.data.body.data.error && rues.data.body.data.error.code) {

    } else if (rues && rues.data && rues.data.body) {
      const catalog = yield select(getDynamicOptions)
      const dataR = rues.data.body.data.registros[0];
      console.log(dataR)
      const razon = yield cleanRazonSocial(emptyObject(dataR.razon_social));

      let step0 = {
        datosinicio: {
          employerNameStart: razon,
          typeIdCompanyStart: emptyObject(tipoId),
          checkNumberStart: emptyObject(dataR.numero_identificacion),
          economicActivityStart: yield returnDataCatalogV2(catalog.economicActivityStart, emptyObject(dataR.cod_ciiu_act_econ_pri), "codigoley", "label"),
          emailCompanyStart: emptyObject(dataR.correo_electronico_comercial),
          emailCompanyCheckStart: emptyObject(dataR.correo_electronico_comercial),
          smartPhoneRegistro: validPhoneRues(emptyObject(dataR.telefono_comercial_1), 3),
        }
      };
      let step1 = { datospersonaladmin: {} };
      let step2 = {
        datosempleador: {
          checkNumber: step0.datosinicio.checkNumberStart,
          digitNumber: emptyObject(dataR.digito_verificacion),
          economicActivity: step0.datosinicio.economicActivityStart,
          emailCompany: step0.datosinicio.emailCompanyStart,
          employerName: step0.datosinicio.employerNameStart,
          typeIdCompany: step0.datosinicio.typeIdCompanyStart
        }
      };
      let step3 = {
        ubicacionempleador: {
          addressCompany: emptyObject(dataR.direccion_comercial),
          cityCompany: "",
          departamentCompany: "",
        },
        ubicacionempleadoraltern: {
          departamentCompanyAlternate: "",
          cityCompanyAlternate: "",
          addressCompanyAlternate: ""
        },
        ubicacionempleadorcontact: {
          phoneCompany: validPhoneRues(emptyObject(dataR.telefono_comercial_2), 6),
          smartPhoneCompany: validPhoneRues(emptyObject(dataR.telefono_comercial_1), 3),
        }
      };
      let step4 = { datosrepresentante: {} };
      console.log(step0, step2, step3)
      if (dataR.vinculos && dataR.vinculos.length > 0) {
        // step4 = {
        //   datosrepresentante: {
        //     numberId: "",
        //     typeId: "",
        //   }
        // };
        //TODO: consulta por rnec
        const repLegal = dataR.vinculos[0];
        if (repLegal?.codigo_clase_identificacion === "01" && repLegal.numero_identificacion && typeEmpleador === "1") {
          respLegal = yield consultaAndLockPersonal({ id: (parseInt(repLegal.numero_identificacion)).toString(), tipo: "CC", nuevo: true, type: "repLegal", rues: true });
        }
      }



      yield put(initialize(FORM_NAME_STEP0, step0));
      yield put(initialize(FORM_NAME_STEP2, step2));
      yield put(initialize(FORM_NAME_STEP3, step3));
      const fmm = dataR.fecha_matricula.split("");
      items = { step0, step1, step2, step3, respLegal, fechaMatriculaMercantil: `${fmm[0]}${fmm[1]}${fmm[2]}${fmm[3]}-${fmm[4]}${fmm[5]}-${fmm[6]}${fmm[7]}` }
    }
    return items;
  } catch (error) {
    console.error(`Function.consumeMapeoRues - saga.js -${error}`);

  }
}

function changeFormatDate(date) {
  /* Cambia el formato de una fecha de separador de guiones a separador de barra
   */
  let newDate = date;
  if (!date.includes("/")) {
    const aux = date.split("-");
    newDate = `${aux[2]}/${aux[1]}/${aux[0]}`
  }
  return newDate;
}

function* consultaPersona(action) {
  /* Consulta la información de una persona a traves de su tipo y numero de identificación
   * primero consulta en sirap y si no hay resultados lo hace en el servicio de la registraduría  
   */
  try {
    let validador = { sirap: false, data: false, registraduria: false, servicioAbajo: false };
    validador.data = yield consumeValidadorSirap(action);
    if (validador.data && validador.data.estadoValidacion === "1") {
      validador.sirap = true;
    } else {
      //consulta en Registraduria
      const perReg = yield consumeConsultaPersonaRegistraduria(action);
      if (perReg.Data && perReg.Data.return?.datosCedulas?.estadoCedula
        && (perReg.Data.return?.datosCedulas.estadoCedula.toUpperCase()).includes("VIGENTE")) {
        validador.data = perReg;
        validador.registraduria = true;
      }

      if (perReg === false) {
        validador.servicioAbajo = true;
      }
    }

    console.log(validador);

    return validador;
  } catch (error) {
    console.error(error, "error")
    throw `Function.consultaPersona - saga.js -${error}`;
  }
}

function* consumeConsultaPersonaRegistraduria(action) {
  /* Web service que recibe el número y tipo de identificación del afiliado
    y valida esta información con la registraduria,
    Aplica solo pa cedulas de ciudadania
   */

  const { id, tipo } = action;
  var date = "";
  var date = new Date();

  const urlConfenalco = process.env.REACT_APP_URL_CONSULTA_PERSONAS;
  const body = {

    "requestMessageOut": {
      "header": {
        "systemId": "PRUEBAS",
        "invokerDateTime": date,
        "destination": {
          "namespace": "http://co/com/comfenalcovalle/esb/ws/ConsultaANI",
          "name": "ConsultaANI",
          "operation": "execute"
        },
        "messageId": `PRUEBAS|CONSULTA|${tipo}${id}`,
        "securityCredential": {
          "userToken": "",
          "userName": ""
        },
        "moduleId": "PRUEBAS",
        "logginData": {
          "sourceSystemId": "",
          "destinationSystemId": ""
        },
        "classification": {
          "classification": ""
        }
      },
      "body": {
        "request": {
          "consultaANIRequest": {
            "abreviatura": tipo,
            "identificacion": id,
          }
        }
      }
    }

  }

  var resul = false;
  try {

    const res = yield consumeServiceGenerico({ body, url: urlConfenalco })
    console.log(res, "servicio registraduria")
    if (res.responseMessageOut.header && res.responseMessageOut.header.responseStatus?.statusCode === "SUCESS") {
      if (res.responseMessageOut.body.response && res.responseMessageOut.body.response.Ok && res.responseMessageOut.body.response.Ok !== "FALSE")
        resul = res.responseMessageOut.body.response;

    }

    return resul;
  } catch (error) {
    console.error(error, "error")
    throw `Function.consumeConsultaPersonaRegistraduria - saga.js -${error}`;
  }
}

function* consumeConsultaEmpresas(action) {
  /* web service que recibe el documento y tipo de documento del afiliado
      y consulta el validador de derechos y retorna la información del afiliado+
   */

  const { id, tipo } = action;
  var date = "";
  var date = new Date();

  const urlConfenalco = process.env.REACT_APP_URL_COMFENALCO_ENDPOINT;

  const body = {

    "requestMessageOut": {
      "header": {
        "systemId": "PRUEBAS",
        "invokerDateTime": date,
        "messageId": `PRUEBAS|CONSULTA|${tipo}${id}`,
        "moduleId": "PRUEBAS",
        "logginData": {
          "sourceSystemId": "",
          "destinationSystemId": ""
        },
        "destination": {
          "namespace": "http://co/com/comfenalcovalle/esb/ws/HCPConsultaEmpresaPorNit",
          "name": "HCPConsultaEmpresaPorNit",
          "operation": "execute"
        },
        "securityCredential": {
          "userName": "",
          "userToken": ""
        },
        "classification": { "classification": "" }
      },
      "body": {
        "request": {
          "informacionEmpresaRequest": {
            "tipoDocumento": tipo,
            "numeroDocumento": id
          }
        }
      }
    }

  }

  var resul = true;
  try {
    console.time("inicio");

    const res = yield consumeServiceGenerico({ body, url: urlConfenalco })
    console.log("Consulta empresas", res)
    if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS") {
      resul = res.responseMessageOut.body.response.empresaResponse;
      if (resul?.mensajeExcepcion) {
        resul = false;
        //no existe, se puede crear
      } else {
        //existe o esta inavilitada, procesar mensaje
        resul = resul.empresa
      }

    } else {
      const msgParametrizados = yield select(getMsgParametrizados);
      yield put(modalInformacionFlujos(
        {
          message: yield generateMsgParametrizado(msgParametrizados, "msgConsultaEmpresasNoDisponible"),
          error: true,
          open: true,
        }));
    }
    console.timeEnd("inicio");
    return resul;
  } catch (error) {
    console.error(error, "error")
    throw error;
  }
}

function* pdfgenera(action) {
  /* función que recibe los datos del formulario, genera el pdf con esos datos
    luego saca el base64 de ese pdf y lo retorna
   */
  const { idFormulario } = action;
  try {

    let solicitudesSession = yield select(getSolicitudes);
    let solicitudes = yield select(getSolicitudesSinfirma);

    if (solicitudes) {

      if (solicitudes.stepPrincipal && solicitudes.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany && parseInt(solicitudes.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany) === 3) {
        solicitudes.step2.datosempleador.startOperation = new Date();
        solicitudesSession.step2.datosempleador.startOperation = solicitudes.step2?.datosempleador?.startOperation;
        yield put(savedSolicitudes({ ...solicitudesSession }));
        yield put(saveSolicitudesSinFirma({ ...solicitudes }))
      }

      solicitudes.step1.datospersonaladmin = yield select(getTableDataPersonal);
      const resul = yield pdf(<MyDocument data={{ ...solicitudes }} />).toBlob();
      let aux = []
      if (resul) {
        const res = yield getBase64(resul)
        aux = res.split(",")[1]
      }
      return aux.length > 1 ? aux : false;
    }
  } catch (error) {
    console.error("function.pdfGenera", error);
    throw `pdfGenera - ${error}`;
  }
}

function* crearTicketAfiliacionEmpresas(action) {
  try {
    /*
función que crea el ticket de afiliación desde el front, 
esto solo sucede cuando ha habido una devolucion y no se ajusta ningun campo dentro del formulario
*/
    const { itemsForm, base64, idFormulario } = action;

    var d = new Date();
    let dateTimes = "";
    dateTimes = d.toLocaleString();
    const catalog = yield select(getCatalogosCargados);

    const inicio = itemsForm.step0.datosinicio;
    const ubicacionContact = itemsForm.step3.ubicacionempleadorcontact;
    const messageID = `${inicio.typeIdCompanyStart}${inicio.checkNumberStart}`
    const representante = itemsForm.step4.datosrepresentante;
    const typeCompany = itemsForm.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany;
    const urlConfenalco = process.env.REACT_APP_COMFENALCO_URL_CREATE_UPDATE_OPORTUNIDAD;

    const body =
    {
      "requestMessageIn": {
        "header": {
          "invokerDateTime": dateTimes,
          "moduleId": "AFILIACIONPATRONAL",
          "systemId": "FOMULARIOS",
          "messageId": messageID,
          "logginData": {
            "sourceSystemId": null,
            "destinationSystemId": null
          },
          "destination": {
            "namespace": "http://co/com/comfenalcovalle/esb/ws/InQueueCRMCreaTicketContactenos",
            "name": "CRMCreaTicketContactenos",
            "operation": "execute"
          },
          "classification": {
            "classification": null
          },
          "messageContext": [
            {
              "key": "timeOut",
              "value": "600000"
            },
            {
              "key": "forgetMessage",
              "value": "true"
            }
          ],
          "routingStack": {
            "routeTo": {
              "callBackTo": {
                "address": "SERVICE.RESPONSE",
                "correlationId": messageID,
                "messageId": messageID
              }
            }
          }
        },
        "body": {
          "request": {
            "accion": "1",//1-->Crear Ticket  2-->Actualizar Ticket
            "tipoCliente": "E",
            "asunto": "Ticket preafilición patronal",
            "tipoIdentificacion": inicio.typeIdCompanyStart,
            "numeroIdentificacion": inicio.checkNumberStart,
            "tipoIdentificacionContacto": representante.typeId,
            "numeroIdentificacionContacto": representante.checkNumber,
            "primerNombreContacto": emptyObject(representante.firstName),
            "segundoNombreContacto": emptyObject(representante.secondName),
            "apellidosContacto": `${emptyObject(representante.firstLastname)} ${emptyObject(representante.secondLastname)}`,
            "correoElectronicoContacto": representante.emailJobBoss,
            "telefonoCelularContacto": representante.smartPhoneBoss,
            "telefonoFijoContacto": null,
            "cargoContacto": returnDataCatalog(catalog.cargos, representante.jobBoss, "label", "value"),
            "generoContacto": representante.sexo,
            "fechaNacimientoContacto": getFechaOfDateV2(representante.birthDate),
            "autenticado": "false",
            "idFormularioTicket": typeCompany === "3" ? "3-1" : typeCompany === "1" ? "3-2" : "3-3",
            "numeroOportunidad": itemsForm.idOportunidad,
            "text": `Datos de contacto:\n\n Correo: ${emptyObject(inicio.emailCompanyStart)} \n Celular: ${emptyObject(inicio.smartPhoneRegistro)} \n Telefono:${ubicacionContact.phoneCompany ? emptyObject(ubicacionContact.phoneCompany) : ""}`,
            "documentos": [
              {
                "base64Archivo": base64,
                "filename": "formulario preafiliacion firmado.pdf",
                "MIMECode": "application/pdf",
              }
            ]
          }
        }
      }
    }


    let resul = false;
    console.time("inicio");
    console.log("body CreaTicket", JSON.stringify(body))
    const res = yield consumeServiceGenerico({ body, url: urlConfenalco });
    console.log("response CreaTicket", res)
    let status = "FAILURE";
    if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS") {
      //TODO: capturar el mensaje de exito
      resul = res.responseMessageOut.body.response.createTicketResponse.ticket_id
      status = "SUCESS"
    } else {
      //TODO: capturar la falla y el proceso a seguir
      notificaFalloWBS({ body, webService: "Actualiza la CreaTicket of devolución", response: res.responseMessageOut.body })
    }

    saveBdWebService(idFormulario, "CRMCreaTicketContactenos", { ...body }, status, res.responseMessageOut.body);

    console.timeEnd("inicio");
    return resul;

  } catch (error) {
    console.error("exception:", error);
    throw `bandeja.js - crearTicketAfiliacionEmpresas - ${error}`;
  }
}


function* bajarFiles(action) {
  /**
   * Función que hace el llamado a una funcion de backend 
   * para descargar los anexos que se han cargado en el formulario
   * se envia las referencias de los anexos, y el buket donde estan almacenados
   */
  try {
    const refes = action;
    const headers = HEADERS_WS;
    const urlservicio = process.env.REACT_APP_URL_CARGAR_FILES;
    const auxfiles = []
    // for (var item of refes) {
    var body = { body: { refStorage: refes, bucket: process.env.REACT_APP_FIREBASE_BUCKET } }

    const resp = yield call(axios.post, urlservicio, body, headers);
    //console.log("init", resp)
    if (resp.data && resp.data.length > 0) {

      for (let element of resp.data) {
        auxfiles.push({
          campo: element.campo,
          name: element.name,
          idFile: element.lastModified,
          nameDoc: element.nameDoc,
          doc: {
            nombreArchivo: element.nameArchivo,
            extensionArchivo: element.typeof,
            contenidoArchivo: element.base64,
          }

        })
        yield put(chargeAnexosStorage({ field: element.campo, name: element.nameArchivo }))
      }

    }


    yield put(saveAnexos({ start: true, data: auxfiles }))

  } catch (error) {
    console.error("function.bajarFiles", error)
    throw error;
  }

}



function* dowloadCatalogAnexos(action) {
  /**
   * Descarga el catalogo de anexos correspondiente a el tipo de empleador de la solicitud
   * y los envia a la tabla del formulario donde se piden
   */

  const { items } = action;
  const empleadorType = items.empleadorTypeCompany;

  const catalog = yield select(getCatalogosCargados);
  const body = {
    "tipoEmpleador": parseInt(empleadorType),
    "tipoIdentificacion": returnDataCatalog(catalog.tiposId, items.typeIdCompanyGes, "value", "id_tiid"),
    "numeroIdentificacion": parseInt(items.numberIdCompanyGes)
  }
  const anexos = yield consultaAnexosService(body);
  console.log(anexos);
  const tableAnexos = [];

  //Si falla la consulta de anexos por medio del ws, por defecto se toman los registros de bd de anexos
  if (anexos && anexos.data && anexos.data.length > 0) {

    anexos.data.forEach(e => {
      // const str = e.descripcion.toLowerCase();
      // const str2 = str.charAt(0).toUpperCase() + str.slice(1);
      tableAnexos.push(
        [{
          "label": e.descripcion.toUpperCase(),

          "value": e.idTiim
        },
        {
          "label": e.obligatoriedad === 'true' ? "SI" : "NO"
        }])
    });



    const dynamicOptions = yield select(getDynamicOptions);
    dynamicOptions.tableOfAnexos = tableAnexos;

    const res = yield put(loadCatalogSuccess(dynamicOptions));
  } else {
    let collection = "ANEXOS_JURIDICA";
    if (empleadorType === "2")
      collection = "ANEXOS_NATURAL";
    if (empleadorType === "3")
      collection = "ANEXOS_DOMESTICA";
    const anexos = yield getAsyncCatalog(collection);
    anexos.forEach(e => {
      tableAnexos.push(

        [{
          "label": e.label.toUpperCase(),

          "value": e.value
        },
        {
          "label": e.obligatorio
        }])
    });

    tableAnexos.push(
      [{
        "label": `GIASS - "Uso exclusivo Comfenalco"`,

        "value": "244"
      },
      {
        "label": false
      }]);

    const dynamicOptions = yield select(getDynamicOptions);
    dynamicOptions.tableOfAnexos = tableAnexos;

    yield put(loadCatalogSuccess(dynamicOptions));
  }
  // } catch (error) {
  //   console.error("function.dowloadCatalogAnexos", error)
  //   throw `saga.js - function.dowloadCatalogAnexo -${error}`
  // }
}

function* consultaAnexosService(action) {
  /**
   * Funcion que consulta a traves de una funccion de backend los anexos requeridos por sirap
   * para la pre-afiliación de empresas
   */
  try {

    const url = process.env.REACT_APP_URL_CONSULTA_ANEXOS_REQUERIDOS;

    let body = action;
    const headers = HEADERS_WS;
    const respues = yield call(axios.post, url, body, headers);
    return respues;
  } catch (error) {
    console.error("Function.consultaAnexosService", error);
    throw error;
  }

}

function* buildDynamicOptions(action) {
  /**
   * Función que consulta los catalogos necesarios para cada selector en el formulario
   * los descarga y los graba en el formulario
   */
  try {
    const { value: { params, rya } } = action;

    yield put(openModalCharged(true));
    if (params) {
      //Se vacia lo que hay en memoria de files para que el proceso inicie nuevamente
      yield put(base64Remove([]));
      const dynamicOptions = {};
      const departament = yield getAsyncCatalog('DEPARTAMENTO');
      const cities = yield getAsyncCatalog('CITIES');
      const cargos = yield getAsyncCatalog('CARGOS');
      const barrios = yield getAsyncCatalog('BARRIOS');
      const clasificaciones = yield getAsyncCatalog('CLASIFICACIONES_ECONOMICAS');
      const sedes = yield getAsyncCatalog('SEDES_REGIONALES');
      const dirPrincipal = yield getAsyncCatalog('DIRECCIONES_PRINCIPAL');
      const dirComplemeto = yield getAsyncCatalog('DIRECCIONES_COMPLEMENTO');
      const idNatural = yield getAsyncCatalog('TIPOS_IDENTIFICACION_NATURAL');
      const claseEmpresa = yield getAsyncCatalog('CLASE_EMPRESA');
      const tipoEmpleador = yield getAsyncCatalog('TIPO_EMPLEADOR');
      const configForm = yield getAsyncCatalog('CONFIG_PARAM_FORM');

      const cargosJob = cargos.filter((e) => parseInt(e.value) !== 585);
      //const documentType = yield getAsyncCatalog('TIPOSDOC');
      dynamicOptions.departamentCompany = departament.sort(ordenar);
      dynamicOptions.departamentCompanyAlternate = departament.sort(ordenar);
      dynamicOptions.jobBoss = cargos.sort(ordenar);
      dynamicOptions.jobBossStaff = cargosJob.sort(ordenar);
      dynamicOptions.economicActivity = (onlyUniqueLabel(clasificaciones)).sort(ordenar);
      dynamicOptions.economicActivityStart = dynamicOptions.economicActivity;
      dynamicOptions.typeId = idNatural.sort(ordenar);
      dynamicOptions.companyClass = claseEmpresa.sort(ordenar);
      dynamicOptions.typeIdStaff = idNatural.sort(ordenar);
      dynamicOptions.sedeRegional = sedes.sort(ordenar);
      dynamicOptions.interseptionType = dirPrincipal.sort(ordenar);
      dynamicOptions.houseType = dirComplemeto.sort(ordenar);
      dynamicOptions.empleadorTypeCompany = tipoEmpleador.sort(ordenar);


      //boton de relacion de trabajadores
      dynamicOptions.workersRelation = [`${process.env.REACT_APP_URL_COMFENALCO_URL_RELACION_TRABAJADORES}`]
      let tiposId = [].concat(dynamicOptions.typeId);
      tiposId.push({ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" })

      yield put(savedCatalogCompany(
        {
          typeId: dynamicOptions.typeId,
          tiposId: tiposId.sort(ordenar),
          actividad: dynamicOptions.economicActivity,
          cargos: dynamicOptions.jobBoss,
          cities: cities.sort(ordenar),
          deptos: dynamicOptions.departamentCompany,
          barrios: barrios.sort(ordenar),
          claseEmpresa: dynamicOptions.companyClass,
          tipoEmpleador: dynamicOptions.empleadorTypeCompany,
          economicActivity: clasificaciones,
          configForm: configForm,
          sedes,
        }));

      const res = yield put(loadCatalogSuccess(dynamicOptions));
      saveInSession('catalog', dynamicOptions);

      //iniciar el formulario directamente
      yield iniFormFromBandeja({ params });

    } else {
      const dynamicOptions = {};
      const idNatural = yield getAsyncCatalog('TIPOS_IDENTIFICACION_NATURAL');
      const claseEmpresa = yield getAsyncCatalog('CLASE_EMPRESA');
      const tipoEmpleador = yield getAsyncCatalog('TIPO_EMPLEADOR');
      const configForm = yield getAsyncCatalog('CONFIG_PARAM_FORM');

      //const documentType = yield getAsyncCatalog('TIPOSDOC');

      dynamicOptions.typeId = idNatural.sort(ordenar);
      dynamicOptions.typeIdStaff = idNatural.sort(ordenar);
      dynamicOptions.empleadorTypeCompany = tipoEmpleador.sort(ordenar);
      dynamicOptions.companyClass = claseEmpresa.sort(ordenar)
      dynamicOptions.workersRelation = [`${process.env.REACT_APP_URL_COMFENALCO_URL_RELACION_TRABAJADORES}`]
      let tiposId = [].concat(dynamicOptions.typeId);
      tiposId.push({ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" })

      yield put(savedCatalogCompany(
        {
          typeId: dynamicOptions.typeId,
          tiposId: tiposId,
          claseEmpresa: claseEmpresa.sort(ordenar),
          tipoEmpleador: dynamicOptions.empleadorTypeCompany,
          configForm: configForm,
        }));

      const res = yield put(loadCatalogSuccess(dynamicOptions));

      yield put(openModalCharged(false));
    }


  } catch (error) {
    console.error("Function.buildDynamicOptions", error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* continuaDowload(action) {
  /**
   * Funcion creada para que se descargue en segundo plano la descarga de catalogos
   * y la carga inicial del formulario sea mas corta
   */
  try {
    const dynamicOptions = yield select(getDynamicOptions);
    const departament = yield getAsyncCatalog('DEPARTAMENTO');
    const cities = yield getAsyncCatalog('CITIES');
    const cargos = yield getAsyncCatalog('CARGOS');
    const barrios = yield getAsyncCatalog('BARRIOS');
    const clasificaciones = yield getAsyncCatalog('CLASIFICACIONES_ECONOMICAS');
    const sedes = yield getAsyncCatalog('SEDES_REGIONALES');
    const dirPrincipal = yield getAsyncCatalog('DIRECCIONES_PRINCIPAL');
    const dirComplemeto = yield getAsyncCatalog('DIRECCIONES_COMPLEMENTO');

    const tamanioFiles = yield getAsyncConfiguration('TAMANIO_MAXIMO_ANEXOS');
    yield put(savedTamanioFiles(tamanioFiles.value));
    //const documentType = yield getAsyncCatalog('TIPOSDOC');
    const cargosJob = cargos.filter((e) => parseInt(e.value) !== 585);

    dynamicOptions.departamentCompany = departament.sort(ordenar);
    dynamicOptions.departamentCompanyAlternate = departament.sort(ordenar);
    dynamicOptions.jobBoss = cargos.sort(ordenar);
    dynamicOptions.jobBossStaff = cargosJob.sort(ordenar);
    dynamicOptions.economicActivity = (onlyUniqueLabel(clasificaciones)).sort(ordenar);
    dynamicOptions.economicActivityStart = dynamicOptions.economicActivity;
    dynamicOptions.sedeRegional = sedes.sort(ordenar);
    dynamicOptions.interseptionType = dirPrincipal.sort(ordenar);
    dynamicOptions.houseType = dirComplemeto.sort(ordenar);
    dynamicOptions.workersRelation = [`${process.env.REACT_APP_URL_COMFENALCO_URL_RELACION_TRABAJADORES}`]
    let tiposId = [].concat(dynamicOptions.typeId);
    tiposId.push({ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" })

    yield put(savedCatalogCompany(
      {
        typeId: dynamicOptions.typeId,
        tiposId: tiposId,
        actividad: dynamicOptions.economicActivity,
        cargos: dynamicOptions.jobBoss,
        cities: cities.sort(ordenar),
        deptos: dynamicOptions.departamentCompany,
        barrios: barrios.sort(ordenar),
        claseEmpresa: dynamicOptions.claseEmpresa,
        tipoEmpleador: dynamicOptions.empleadorTypeCompany,
        economicActivity: clasificaciones,
        sedes,
      }));

    const res = yield put(loadCatalogSuccess(dynamicOptions));
    saveInSession('catalog', dynamicOptions);
  } catch (error) {
    console.error(error)
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* actualizarContatosOportunidad(action) {
  /*
función que valida si hay cambios en la informacion de contacto, 
respecto a la que se registro anteriormente o se agrega nueva información
*/
  const { items, idFormulario } = action
  try {

    const personal = yield select(getPersonalAdmin)

    if (personal && personal.length > 0) {
      //antes habian 

      if (items.step1 && items.step1.datospersonaladmin.length > 0) {
        //ahora hay
        if (JSON.stringify(items.step1.datospersonaladmin) !== JSON.stringify(personal)) {
          //hay cambios
          yield consumeActualizaOportunidad({ faseVenta: "Z21", anexos: false, itemsForm: items, nota: createNotaOportunidad({ items: items }) })
          yield put(savePersonalAdmin({ data: [...items.step1.datospersonaladmin] }))
        }
      }
    } else {
      if (items.step1 && items.step1.datospersonaladmin.length > 0) {
        //hay nuevos
        yield consumeActualizaOportunidad({ faseVenta: "Z21", anexos: false, itemsForm: items, nota: createNotaOportunidad({ items: items }) })
        yield put(savePersonalAdmin({ data: [...items.step1.datospersonaladmin] }))
      }
    }

  } catch (error) {
    console.error("saga.js - actualizarContatosOportunidad-", error)
    throw error;
  }
}

function* saveEraser(action) {
  /**
   * Función que se encarga de guardar los datos del formulario en la BD
   * esto sucede cada que se realiza la accion de dar en siguiente 
   */
  const { final } = action;
  try {

    var items = yield select(fullFormSelector);

    let valid = yield validateForm(items);
    if (valid.valid) {

      const solicitudes = yield select(getSolicitudes);
      const ruesData = yield select(getDataRues);

      items.step0 = items.step0 ? items.step0 : {};
      items.step2 = items.step2 ? items.step2 : {};
      items.step3 = items.step3 ? items.step3 : {};
      items.step4 = items.step4 ? items.step4 : {};
      items.step1 = items.step1 ? items.step1 : {};
      items.stepPrincipal = items.stepPrincipal ? items.stepPrincipal : {};
      items.notificacion = 1;
      items.date = new Date();
      items.dateCreation = items.date;
      items.iduser = yield select(getIdUser);
      items.refeFiles = yield select(getRefeFiles);
      items.step1.datospersonaladmin = yield select(getTableDataPersonal);
      items.stepPrincipal = yield select(getDataPantallaInicio);
      items.refeBarcode = yield select(getReferenceBarcode);
      items.dataRnec = yield select(getDatosConsultaRnec);


      if (!solicitudes)
        yield put(savedSolicitudes({ ...items }))

      const idApp = yield select(getIdAppForm);
      items.idOportunidad = idApp.idOportunidad;
      items.asesorAsigna = idApp.asesorAsigna;

      if (solicitudes) {
        if (solicitudes.dateCreation) {
          items.dateCreation = solicitudes.dateCreation;
        }

        if (solicitudes.aprobacion && solicitudes.aprobacion.fecha) {
          items.aprobacion = solicitudes.aprobacion;
        }

        if (solicitudes.devolucion && solicitudes.devolucion.motivo) {
          items.devolucion = solicitudes.devolucion;
        }

        if (solicitudes.devolucionComercial && solicitudes.devolucionComercial.motivo) {
          items.devolucionComercial = solicitudes.devolucionComercial;
        }

        if (solicitudes.validComercial && solicitudes.validComercial.fechaIni) {
          items.validComercial = solicitudes.validComercial;
        }

        if (solicitudes.validRya && solicitudes.validRya.fechaIni) {
          items.validRya = solicitudes.validRya;
        }

        if (solicitudes.dateFirma) {
          items.dateFirma = solicitudes.dateFirma;
        }

        if (solicitudes.dateReenvio) {
          items.dateReenvio = solicitudes.dateReenvio;
        }

        if (solicitudes.dateValidation) {
          items.dateValidation = solicitudes.dateValidation;
        }

        if (solicitudes.ticketAfiliacion && solicitudes.ticketAfiliacion.length > 0) {
          items.ticketAfiliacion = solicitudes.ticketAfiliacion;
        }

        if (solicitudes.idDocu) {
          items.idDocu = solicitudes.idDocu;
        }

        if (solicitudes.fechaMatriculaMercantil) {
          items.fechaMatriculaMercantil = solicitudes.fechaMatriculaMercantil;
        } else {
          if (ruesData) {
            items.fechaMatriculaMercantil = ruesData.fechaMatriculaMercantil;
          }
        }
      }
      var idFormulario = yield select(getIdFormulario);

      if (!idFormulario) {
        items.notificacion = 0;
        var refcon = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc();
        idFormulario = refcon.id;
        yield put(saveIdFormulario(idFormulario))
      }

      const formDevuelto = yield select(getFormDevuelto);
      if (!final) {
        yield actionSavedNotFinally({ formDevuelto: { ...formDevuelto }, idFormulario, items: { ...items }, idApp: { ...idApp } })
      } else {
        yield actionSavedFinally({ formDevuelto: { ...formDevuelto }, idFormulario, items: { ...items }, solicitudes: { ...solicitudes } })
      }

    } else {
      yield put(modalInformacionFlujos(
        {
          message: valid.campo,
          error: true,
          open: true,
        }));
    }
  } catch (error) {
    console.error("Function.saveEraser", error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }

}

function* validateChangesFromBandeja(action) {
  try {
    const empleadorType = yield select(getEmpleadorType);
    let changesForm = yield select(getSoportRnec);
    if ((empleadorType !== "3" && action.value === 5) || (empleadorType === "3" && action.value === 4)) {
      const solicitudes = yield select(getSolicitudes);
      const data = yield select(getFormValuesStep4);
      if (JSON.stringify(solicitudes.step4.datosrepresentante) !== JSON.stringify(data.datosrepresentante)) {
        changesForm = true;
        const idFormulario = yield select(getIdFormulario);
        yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step4: data, soportRnec: true }, { merge: true });


        let infoUser = yield select(getUserInfoComercial);
        if (!infoUser)
          infoUser = yield select(getUserPersona);

        const history = {
          fechaHistory: new Date(),
          tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
          infoUsuario: infoUser,
          resultadoValidacion: {
            accionRealizada: "Representante legal editado desde la bandeja",
            observacion: `Se modificó la información de el representante legal, por asesor`,
          }
        }

        saveHistoryEmpresas({ history, idFormulario });
      }

      if (changesForm) {

        let dynamicOptions = yield select(getDynamicOptions);
        dynamicOptions.tableOfAnexos.push(
          [{
            "label": `Soporte de registraduria`,

            "value": "248"
          },
          {
            "label": false
          }]);
        yield put(loadCatalogSuccess(dynamicOptions));
      }

    }
  } catch (error) {
    throw `${error}`
  }
}

function* validPersonExist(action) {
  try {
    const { id, type, campo } = action;
    const representante = yield select(getFormValuesStep4);
    const contacto = yield select(getTableDataPersonal);
    const inicio = yield select(getFormValuesStep0);
    const empleadorType = yield select(getEmpleadorType)

    let exist = false;
    let message = "";
    if (campo === "representante") {
      if (contacto && contacto.length > 0) {
        const findId = contacto.find(e => e.numberIdStaff === id && e.typeIdStaff === type)
        if (findId) {
          exist = true;
          message = `Al ingresar la misma persona como representante legal que ya se encuentra en la seccion "Datos de contacto", se eliminara de esa sección y quedara solamente como "Representante legal".`;
        }
      }
    } else {
      if (empleadorType === "2") {
        if (inicio && inicio.datosinicio && inicio.datosinicio.checkNumberStart === id && inicio.datosinicio.typeIdCompanyStart === type) {
          exist = true;
          message = "No debe ingresar al empleador como contacto administrativo.";
        }

      }
      if (representante && representante.datosrepresentante && representante.datosrepresentante.numberId === id && representante.datosrepresentante.typeId === type) {
        exist = true
        message = "No debe ingresar al representante legal como contacto administrativo.";
      }
      if (contacto && contacto.length > 0) {
        const findId = contacto.find(e => e.numberIdStaff === id && e.typeIdStaff === type)
        if (findId) {
          exist = true
          message = "No se puede ingresar la misma persona o número de identificación mas de 1 vez";
        }
      }
    }

    return { exist, message };

  } catch (error) {
    throw `saga.js - validPersonExist- ${error}`

  }
}

function* actionSavedNotFinally(action) {
  /*proceso de guardado cuando la postulacion no se ha finalizado
  */
  let { items, formDevuelto, idFormulario, idApp } = action;
  try {
    let banSave = true;
    let activeStep = yield select(getActiveStep);
    const customer = yield select(getFormularioCustomer);
    if (activeStep === 0 && !idApp.idOportunidad) {
      const resOpor = yield actionsStep1({ items, idFormulario });
      if (resOpor && resOpor.oportunidad) {
        items.idOportunidad = resOpor.oportunidad.idOportunidad;
        items.asesorAsigna = resOpor.oportunidad.asesorAsigna;
        yield put(increaseSiguiente({ state: true }))
      } else {
        banSave = false;
        if (resOpor && resOpor.invalidActivity) {
          yield put(modalInformacionFlujos(
            {
              message: "De acuerdo actividad economica ingresada debe iniciar proceso nuevamente (Presione F5), seleccionando tipo de empleador Domestico.",
              error: true,
              open: true,
            }));
        } else {
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgGeneralServicioNoDisponible"),
              error: true,
              open: true,
            }));
        }
      }
    } else if (activeStep === 0 && idApp.idOportunidad) {
      yield actionsStep1Oportunidad({ items });
      yield put(increaseSiguiente({ state: true }));
    } else if (activeStep === 1) {
      yield put(openModalCharged(true));
      if (parseInt(items.stepPrincipal?.afiliacionEmpresas?.empleadorTypeCompany) !== 3) {
        //verificar si hay cambios en contactos y actualizar
        yield actualizarContatosOportunidad({ items, idFormulario });

      }

      // en el caso de domestico y natural se inicializa el corre de representante legal 
      let dataStep4 = yield select(getFormValuesStep4);
      if (emptyJson(dataStep4)) {
        dataStep4 = { datosrepresentante: {} }
      }
      let lote = [{ field: "jobBoss", state: true }];
      if (!items.stepPrincipal?.afiliacionEmpresas?.empleadorTypeCompany === "1") {
        lote.push({ field: "emailJobBoss", state: true });
        dataStep4.datosrepresentante.emailJobBoss = items.step0?.datosinicio?.emailCompanyStart;
      }
      dataStep4.datosrepresentante.jobBoss = "Representante legal directores y gerentes generales"
      yield put(callDinamicDisableLote(lote))
      yield put(initialize(FORM_NAME_STEP4, dataStep4));

      yield put(openModalCharged(false));
      yield put(increaseSiguiente({ state: true }))
    } else if (activeStep === 3) {
      let banAsk = false;
      if (items.step2.ubicacionempleadorask && items.step2.ubicacionempleadorask.empleadorCajaAsk === "1")
        banAsk = true;

      let dynamicOptions = yield select(getDynamicOptions);
      let tableAnexos = []
      if (dynamicOptions.tableOfAnexos) {
        dynamicOptions.tableOfAnexos.forEach(e => {
          if (e[0].label.includes("PAZ Y SALVO DESAFILIACION"))
            tableAnexos.push(
              [{
                "label": e[0].label,

                "value": e[0].value
              },
              {
                "label": banAsk === true ? "SI" : "NO"
              }])
          else
            tableAnexos.push(e)
        });
      }
      dynamicOptions.tableOfAnexos = tableAnexos;
      yield put(loadCatalogSuccess(dynamicOptions));
      yield put(increaseSiguiente({ state: true }));
      if (items.stepPrincipal?.afiliacionEmpresas?.empleadorTypeCompany === "3")
        yield put(saveSolicitudesSinFirma({ ...items }))

    } else if (activeStep === 4) {
      yield put(saveSolicitudesSinFirma({ ...items }))
      yield put(increaseSiguiente({ state: true }));

    } else if (activeStep === 1) {
      if (items.stepPrincipal?.afiliacionEmpresas?.empleadorTypeCompany === "3") {
        yield put(increaseSiguiente({ state: true }))
      } else {
        const itemsStep1 = yield select(getFormValuesStep1);
        if (itemsStep1) {
          yield put(modalInformacionFlujos(
            {
              message: "Debe terminar con el diligenciamiento de la información dentro de la sección, o limpiar la informacion diligenciada. Por favor ingresar los campos requeridos: ",
              error: true,
              open: true,
            }));
        } else {
          yield put(increaseSiguiente({ state: true }))
        }
      }
    } else {
      yield put(increaseSiguiente({ state: true }))
    }

    if (customer.state) {
      items.asistido = {
        asesor: "comercial",
        email: customer.email,
        name: customer.name
      }
    }

    items.state = formDevuelto.state;
    items.devueltoAndModified = formDevuelto.modified;

    //TODO datos del comercial
    if (banSave)
      yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set(items);

  } catch (error) {
    throw `actionSavedNotFinally - ${error}`
  }
}

function* actionSavedFinally(action) {
  /*proceso de guardado cuando en la postulacion se ha pinchado el boton finalizar
  */

  let { items, formDevuelto, idFormulario, solicitudes } = action;

  try {

    if (solicitudes.stepPrincipal && solicitudes.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany === "3" && solicitudes.step2.datosempleador && solicitudes.step2.datosempleador.startOperation) {
      items.step2.datosempleador.startOperation = solicitudes.step2.datosempleador.startOperation;
    }


    yield put(closeFinalModal())
    let respIdDocu = false;
    if (items && items.idDocu) respIdDocu = { data: { code: items.idDocu, refeBarcode: items.refeBarcode } };
    else respIdDocu = yield enviarBarcode({ idFormulario });

    if (respIdDocu && respIdDocu.data) {
      items.step2.datosempleador.digitNumber = calcularDigitoVerificacion(items.step2.datosempleador.checkNumber);
      items.refeBarcode = respIdDocu.data.refeBarcode;
      items.idDocu = respIdDocu.data.code;
      let anexos = yield select(getbase64Add);

      yield put(saveSolicitudesSinFirma({ ...items }));

      const anexosUpdate = yield select(getBase64Start);
      if (formDevuelto.state === estados.DEVUELTA) {
        let newAnexos = [];
        anexos.forEach(i => {
          let banExists = false;
          anexosUpdate.forEach(e => {
            if (i.idFile === e.idFile && i.campo === e.campo) {
              banExists = true;
            }

          });
          if (!banExists) {
            newAnexos.push(i);
          }
        });
        anexos = [...newAnexos];
      }

      const reenvio = formDevuelto.state === estados.DEVUELTA ? true : false;

      const changesForm = yield validarCambios(items, solicitudes);


      if (formDevuelto.state === estados.DEVUELTA && !changesForm) {
        let base64Formulario = false;
        if (anexosUpdate && anexosUpdate.length > 0) {
          base64Formulario = anexosUpdate.find(e => e.campo === "pdfFirmadoAdobe");
        }

        let infoUser = yield select(getUserInfoComercial);
        if (!infoUser)
          infoUser = yield select(getUserPersona);

        let ticket = false;
        if (items && items.ticketAfiliacion && items.ticketAfiliacion.length > 0) {
          ticket = items.ticketAfiliacion;
        }
        const consultaTicket = yield consumeConsultaTicket({ items, idFormulario });
        console.log(consultaTicket);
        if (consultaTicket)
          if (consultaTicket.exist)
            ticket = consultaTicket.ticketAfiliacion;


        if (consultaTicket.exist === false || (ticket === false && !consultaTicket.exist)) {

          ticket = yield crearTicketAfiliacionEmpresas({ itemsForm: items, base64: base64Formulario && base64Formulario.campo ? base64Formulario.doc.contenidoArchivo : "", idFormulario });
          if (ticket) {
            items.dateReenvio = new Date();
            items.ticketAfiliacion = ticket;
            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ dateReenvio: items.dateReenvio, ticketAfiliacion: items.ticketAfiliacion }, { merge: true });
            const history = {
              fechaHistory: new Date(),
              tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
              infoUsuario: infoUser,
              resultadoValidacion: {
                accionRealizada: "Creación ticket afiliacion",
                observacion: `Creación ticket ${ticket} afiliacion a partir de una devolución`
              },
            }
            yield put(savedSolicitudes({ ...items }));

            saveHistoryEmpresas({ history, idFormulario });
          }
        }
        if (ticket) {

          const resActOpor = yield consumeActualizaOportunidad({ ticket, faseVenta: "Z96", anexos, itemsForm: items, nota: "Se cargaron anexos exitosamente", idFormulario: false, reenvio })
          if (resActOpor) {

            items.state = items.asesorAsigna && items.asesorAsigna.email ? estados.VALIDACION_CORPORATIVO : estados.VALIDACION_COMERCIAL;

            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ state: items.state }, { merge: true });

            const history = {
              fechaHistory: items.dateReenvio,
              tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
              infoUsuario: infoUser,
              resultadoValidacion: {
                accionRealizada: "Finalizado sin modificaciones al pdf",
                observacion: "Finalizado a partir de una devolución"
              },
            }
            saveHistoryEmpresas({ history, idFormulario });

            yield put(openModalCharged(false));

            const msgParametrizados = yield select(getMsgParametrizados);
            yield put(openFinalModal({
              message: yield generateMsgParametrizado(msgParametrizados, "msgPdfAdobeSuccesReenvio"),
              error: false,
              open: true,
            }));


          } else {
            yield put(openModalCharged(false));
            const msgParametrizados = yield select(getMsgParametrizados);
            yield put(modalInformacionFlujos(
              {
                message: yield generateMsgParametrizado(msgParametrizados, "msgGeneralServicioNoDisponible"),
                error: true,
                open: true,
              }));
          }

        } else {
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgGeneralServicioNoDisponible"),
              error: true,
              open: true,
            }));
        }

      } else {
        items.state = estados.BORRADOR;

        yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set(items);

        let infoUser = yield select(getUserInfoComercial);
        if (!infoUser)
          infoUser = yield select(getUserPersona);
        const history = {
          fechaHistory: new Date(),
          tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
          infoUsuario: infoUser,
          resultadoValidacion: {
            accionRealizada: "Finalizado enviado para firma",
            observacion: "Finalizado y listo para firmar, enviado por adobesign"
          },
        }
        saveHistoryEmpresas({ history, idFormulario })
        //Actualizar fase de venta Z92

        const resActuOpor = yield consumeActualizaOportunidad({ faseVenta: "Z92", anexos: anexos, itemsForm: items, nota: "Se cargaron anexos exitosamente", idFormulario, reenvio })
        if (resActuOpor) {

          yield enviarPdfParaFirma({ idFormulario, items });
        }
        else {
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgGeneralServicioNoDisponible"),
              error: true,
              open: true,
            }));
        }
        yield put(openModalCharged(false));
      }
    } else {
      yield put(openModalCharged(false));
      const msgParametrizados = yield select(getMsgParametrizados);
      yield put(modalInformacionFlujos(
        {
          message: yield generateMsgParametrizado(msgParametrizados, "msgGeneralServicioNoDisponible"),
          error: true,
          open: true,
        }));
    }



  } catch (error) {
    throw `actionSavedFinally - ${error}`
  }
}

function* enviarPdfParaFirma(action) {
  /**
   * Funccion que envia el pdf generado del formulario por medio de adobe Sign
   * para el usuario para que este realice la firma digital del mismo
   */
  const { idFormulario, items } = action;

  try {
    let base64File = yield pdfgenera({ idFormulario });

    const headers = HEADERS_WS;
    const urlservicio = process.env.REACT_APP_URL_SEND_PDF_ADOBE_SIGN;
    let email = "";

    email = items.step0.datosinicio.emailCompanyStart;

    var body = { idFormulario, file: base64File, email, fileName: "inscripcionEmpresas.pdf" }
    const resp = yield call(axios.post, urlservicio, body, headers);

    if (resp.data && resp.data.acuerdoAdobeSign) {
      let infoUser = yield select(getUserInfoComercial);
      if (!infoUser)
        infoUser = yield select(getUserPersona);
      const history = {
        fechaHistory: new Date(),
        tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
        infoUsuario: infoUser,
        resultadoValidacion: {
          accionRealizada: "Enviado para firma",
          observacion: "Pendiente de firma"
        },
      }
      saveHistoryEmpresas({ history, idFormulario })

      yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ "acuerdoAdobeSign": resp.data.acuerdoAdobeSign, state: estados.ENVIADO_PARA_FIRMA, date: history.fechaHistory }, { merge: true });
      yield put(openModalCharged(false));

      const msgParametrizados = yield select(getMsgParametrizados);
      yield put(openFinalModal({
        message: yield generateMsgParametrizado(msgParametrizados, "msgPdfAdobeFirmaSucces"),
        error: false,
        open: true,
      }));

    } else {
      yield put(openModalCharged(false));
      const msgParametrizados = yield select(getMsgParametrizados);
      yield put(modalInformacionFlujos(
        {
          message: yield generateMsgParametrizado(msgParametrizados, "msgGeneralServicioNoDisponible"),
          error: true,
          open: true,
        }));
    }
  } catch (error) {
    console.error("Function.enviarPdfParaFirma ", error);
    throw `Function.enviarPdfParaFirma - saga.js- ${error}`;
  }
}

function* actionsStep1(action) {

  /**
   * Función que carga los datos en el step inicial el cual genera la oportunidad en el crm
   * 
   */
  const { items, idFormulario, oportunidad } = action;
  console.log(action)
  try {


    let ban = {
      invalidActivity: false,
      oportunidad: false,
    };
    //inicializar los campos
    const catalogo = yield select(getCatalogosCargados);
    var newData = {};

    newData = {
      disable: false,
      options: catalogo.typeId,
      field: "typeIdCompany",
    };
    let invalidActivity = false;
    if (items.stepPrincipal.afiliacionEmpresas?.empleadorTypeCompany === "2") {
      if (items.step0.datosinicio.economicActivityStart.includes("9700"))
        invalidActivity = true;
    }
    if (invalidActivity) {
      ban.invalidActivity = true;
    } else {
      if (items.stepPrincipal.afiliacionEmpresas?.empleadorTypeCompany === "1") {
        newData.options = [{ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" }];
        yield put(callDinamicDisable({ field: "smartPhoneBoss", state: false }));
        yield put(callDinamicDisable({ field: "emailJobBoss", state: false }));
      }

      yield put(loadDocumentSuccess(newData));

      yield put(change(FORM_NAME_STEP3, "ubicacionempleadorcontact.smartPhoneCompany", items.step0.datosinicio.smartPhoneRegistro));

      let auxDataStep2 = yield select(getFormValuesStep2);

      auxDataStep2.datosempleador["employerName"] = items.step0.datosinicio.employerNameStart;
      auxDataStep2.datosempleador["typeIdCompany"] = items.step0.datosinicio.typeIdCompanyStart;
      auxDataStep2.datosempleador["checkNumber"] = items.step0.datosinicio.checkNumberStart;
      auxDataStep2.datosempleador["emailCompany"] = items.step0.datosinicio.emailCompanyStart;
      auxDataStep2.datosempleador["employedNumber"] = items.step0.datosinicio.employedNumberStar;
      auxDataStep2.datosempleador["employedNumber"] = items.step0.datosinicio.employedNumberStart;
      auxDataStep2.datosempleador["payrollMonth"] = items.step0.datosinicio.payrollMonthStart;
      auxDataStep2.datosempleador["economicActivity"] = items.step0.datosinicio.economicActivityStart;

      yield put(initialize(FORM_NAME_STEP2, auxDataStep2));

      yield put(createUserPerson({
        id: items.step0.datosinicio.checkNumberStart,
        tipoId: items.step0.datosinicio.typeIdCompanyStart,
        rol: "Empresa",
        email: items.step0.datosinicio.emailCompanyStart,
        nameCompleted: items.step0.datosinicio.employerNameStart
      }))

      if (items.stepPrincipal.afiliacionEmpresas?.empleadorTypeCompany !== "1") {
        //Para el caso de empleador domestico y natural se inicializa el correo y el celular, en la pestaña representante

        yield put(callDinamicDisable({ field: "smartPhoneBoss", state: true }));
        yield put(change(FORM_NAME_STEP4, "datosrepresentante.smartPhoneBoss", items.step0.datosinicio.smartPhoneRegistro));
        yield put(callDinamicDisable({ field: "emailJobBoss", state: true }));
        yield put(change(FORM_NAME_STEP4, "datosrepresentante.emailJobBoss", items.step0.datosinicio.emailCompanyStart));

      }

      //crear oportunidad
      if (!(items && items.step2?.datosempleador?.processNumber)) {
        const activeRyA = yield select(getActiveFormRya);

        if (!activeRyA && items.notificacion === 0) {
          yield put(openModalCharged(true));
          //TODO: pendiente implementacion completa servicios del crm
          const num_opor = yield consumeOportunidad({ items });

          if (num_opor && num_opor.oportunidad) {
            const idApp = num_opor.oportunidad;

            const objOportunidad = { "idOportunidad": idApp, asesorAsigna: num_opor.asesorAsigna }
            ban.oportunidad = objOportunidad;
            //TODO: para test no se consumen servicios del crm

            let step2 = yield select(getFormValuesStep2);
            step2.datosempleador.processNumber = idApp;
            yield put(initialize(FORM_NAME_STEP2, step2));

            //Consume servicio anexos requeridos
            yield dowloadCatalogAnexos({ items: items.stepPrincipal.afiliacionEmpresas })

            yield put(openModalCharged(false));
            yield put(savedIdApp(objOportunidad));
            yield put(openModalFormularioRegistro(
              {
                message: `Para esta solicitud se ha generado el número de registro : `,
                open: true,
                form: `${idApp}`,
                messageFinal: `Por favor conservelo para ingresar nuevamente a este proceso de inscripción`,
              }));
            //yield enviarEmail({ idFormulario: idApp, email: items.step0.datosinicio.emailCompanyStart });

            let infoUser = yield select(getUserInfoComercial);

            if (!infoUser) {
              infoUser = {
                id: items.step0.datosinicio.checkNumberStart,
                tipoId: items.step0.datosinicio.typeIdCompanyStart,
                rol: "Empresa",
                email: items.step0.datosinicio.emailCompanyStart,
                nameCompleted: items.step0.datosinicio.employerNameStart
              }
            }
            const history = {
              fechaHistory: items.dateCreation,
              tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
              infoUsuario: infoUser,
              resultadoValidacion: {
                accionRealizada: "Creación",
                observacion: "Se crea una postulación para esta empresa"
              },
            }

            saveHistoryEmpresas({ history, idFormulario })
          }

        }
        yield put(openModalCharged(false));
      }
    }
    yield put(openModalCharged(false));

    return ban;
  } catch (error) {
    throw `saga.js  actionsStep1- ${error}`
  }
}

function* actionsStep1Oportunidad(action) {

  /**
   * Función que realiza las acciones pertinentes despues que el proceso de crear la oportunidad resulte exitoso
   *
   */
  const { items } = action;
  //inicializar los campos 

  try {
    const catalogo = yield select(getCatalogosCargados);
    var newData = {};

    newData = {
      disable: false,
      options: catalogo.typeId,
      field: "typeIdCompany",
    };

    if (items.stepPrincipal.afiliacionEmpresas?.empleadorTypeCompany === "1") {
      newData.options = [{ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" }];
      yield put(callDinamicDisable({ field: "smartPhoneBoss", state: false }));
      yield put(callDinamicDisable({ field: "emailJobBoss", state: false }));
    }

    yield put(loadDocumentSuccess(newData));

    yield put(change(FORM_NAME_STEP3, "ubicacionempleadorcontact.smartPhoneCompany", items.step0.datosinicio.smartPhoneRegistro));

    let auxDataStep2 = yield select(getFormValuesStep2);

    auxDataStep2.datosempleador["employerName"] = items.step0.datosinicio.employerNameStart;
    auxDataStep2.datosempleador["typeIdCompany"] = items.step0.datosinicio.typeIdCompanyStart;
    auxDataStep2.datosempleador["checkNumber"] = items.step0.datosinicio.checkNumberStart;
    auxDataStep2.datosempleador["emailCompany"] = items.step0.datosinicio.emailCompanyStart;
    auxDataStep2.datosempleador["employedNumber"] = items.step0.datosinicio.employedNumberStar;
    auxDataStep2.datosempleador["employedNumber"] = items.step0.datosinicio.employedNumberStart;
    auxDataStep2.datosempleador["payrollMonth"] = items.step0.datosinicio.payrollMonthStart;
    auxDataStep2.datosempleador["economicActivity"] = items.step0.datosinicio.economicActivityStart;

    yield put(initialize(FORM_NAME_STEP2, auxDataStep2));


    yield put(createUserPerson({
      id: items.step0.datosinicio.checkNumberStart,
      tipoId: items.step0.datosinicio.typeIdCompanyStart,
      rol: "Empresa",
      email: items.step0.datosinicio.emailCompanyStart,
      nameCompleted: items.step0.datosinicio.employerNameStart
    }))

    if (items.stepPrincipal.afiliacionEmpresas?.empleadorTypeCompany !== "1") {
      //Para el caso de empleador domestico y natural se inicializa el correo y el celular, en la pestaña representante 

      yield put(callDinamicDisable({ field: "smartPhoneBoss", state: true }));
      yield put(change(FORM_NAME_STEP4, "datosrepresentante.smartPhoneBoss", items.step0.datosinicio.smartPhoneRegistro));
      yield put(callDinamicDisable({ field: "emailJobBoss", state: true }));
      yield put(change(FORM_NAME_STEP4, "datosrepresentante.emailJobBoss", items.step0.datosinicio.emailCompanyStart));

    }
  } catch (error) {
    throw `saga.js  actionsStep1Oportunidad- ${error}`
  }
}

function create_id_oportunidad(empleador, sucursal) {
  const listPatronal = [
    { "empleador": "1", "sucursal": "0", "value": "2-15" },
    { "empleador": "1", "sucursal": "1", "value": "2-15" },
    { "empleador": "1", "sucursal": "8", "value": "2-16" },
    { "empleador": "1", "sucursal": "127", "value": "2-17" },
    { "empleador": "1", "sucursal": "124", "value": "2-18" },
    { "empleador": "1", "sucursal": "130", "value": "2-19" },
    { "empleador": "1", "sucursal": "126", "value": "2-20" },
    { "empleador": "2", "sucursal": "1", "value": "2-15" },
    { "empleador": "2", "sucursal": "0", "value": "2-15" },
    { "empleador": "2", "sucursal": "8", "value": "2-16" },
    { "empleador": "2", "sucursal": "127", "value": "2-17" },
    { "empleador": "2", "sucursal": "124", "value": "2-18" },
    { "empleador": "2", "sucursal": "130", "value": "2-19" },
    { "empleador": "2", "sucursal": "126", "value": "2-20" },
    { "empleador": "3", "sucursal": "0", "value": "2-21" },
    { "empleador": "3", "sucursal": "1", "value": "2-21" },
    { "empleador": "3", "sucursal": "8", "value": "2-22" },
    { "empleador": "3", "sucursal": "127", "value": "2-23" },
    { "empleador": "3", "sucursal": "124", "value": "2-24" },
    { "empleador": "3", "sucursal": "130", "value": "2-25" },
    { "empleador": "3", "sucursal": "126", "value": "2-26" },
  ]


  try {

    const res = listPatronal.find(e => e.empleador === empleador && e.sucursal === sucursal);
    return res.value;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function create_tamanio_company(numberEmployed) {
  try {
    let res = ""
    if (numberEmployed > 200)
      res = 4;
    else if (numberEmployed > 50)
      res = 3;
    else if (numberEmployed > 10)
      res = 2;
    else
      res = 1;
    return res.toString();
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* consumeActualizaOportunidad(action) {
  /*Función que actualiza la oportunidad
   *Recibe, el tipo de identificacion y el numero, la fase de venta, y una nota si la hay
   *Si el formulario genero algun error se envia un json diferente 
   */
  const { faseVenta, anexos, itemsForm, nota, idFormulario, ticket, reenvio } = action;

  const id = itemsForm.stepPrincipal.afiliacionEmpresas.numberIdCompanyGes;
  const tipo = itemsForm.stepPrincipal.afiliacionEmpresas.typeIdCompanyGes;
  const idApp = yield select(getIdAppForm);
  const idOportunidad = idApp.idOportunidad;
  const messageid = tipo + id;

  var date = "";
  var date = new Date();
  //const files = yield select(getbase64Add);
  var archivo = [];
  let complement = ` ${yield getCodeOfDateSystem()}`


  if (anexos && anexos.length > 0) {
    anexos.forEach(e => {
      const auxNameFile = e.doc.nombreArchivo.split(".");
      //Para el nombre del archivo enviamos el nombre del documento al que hace referencia Ej. Fotocopia de cedula
      archivo.push({
        contenidoArchivo: e.doc.contenidoArchivo,
        extensionArchivo: e.doc.extensionArchivo,
        nombreArchivo: `${e.nameDoc}${complement}.${auxNameFile[auxNameFile.length - 1]}`
      })
    });

  }
  if (faseVenta === "Z92" && idFormulario) {
    //anexar formulario sin firma 
    const pdfSinFirma = yield select(getBase64pdfSinFirma);
    let base64File = ""
    if (pdfSinFirma && pdfSinFirma.data && pdfSinFirma.data.length > 0) {
      //tenemos el base 64 
      base64File = pdfSinFirma.data;
    } else {
      base64File = yield pdfgenera({ idFormulario });
    }

    archivo.push({
      contenidoArchivo: base64File,
      extensionArchivo: "application/pdf",
      nombreArchivo: `Formulario preafiliacion sin firma${complement}.pdf`
    })
  }

  var infoOportu = {
    "idOportunidad": idOportunidad,
    "faseVenta": faseVenta,
    "archivo": archivo,
    "idTicket": ticket,
    "nota": nota //tipo id nombre correo celular cargo \n tipo id nombre correo celular cargo
  }

  const urlConfenalco = process.env.REACT_APP_COMFENALCO_URL_CREATE_UPDATE_OPORTUNIDAD;

  const body = {
    "requestMessageOut": {
      "header": {
        "invokerDateTime": date,
        "moduleId": "OPORTUNIDAD",
        "systemId": "FORMULARIOSWEB",
        "messageId": messageid,
        "logginData": {
          "sourceSystemId": "",
          "destinationSystemId": ""
        },
        "destination": {
          "namespace": "http://co/com/comfenalcovalle/esb/ws/CRMCreaActualizaOportunidad",
          "name": "CRMCreaActualizaOportunidad",
          "operation": "execute"
        },
        "securityCredential": {
          "userName": "",
          "userToken": ""
        },
        "classification": {
          "classification": ""
        }
      },
      "body": {
        "request": {
          "oportunidad": {
            "accion": "2",
            "infoOportunidad": infoOportu,
          }
        }
      }
    }
  }
  var resul = false;
  try {
    console.time("inicio");
    console.log("body ActualizaOportunidad", JSON.stringify(body))
    const res = yield consumeServiceGenerico({ body, url: urlConfenalco });
    console.log("response oportunidad", res)

    const idForm = yield select(getIdFormulario);
    let status = "FAILURE";
    if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS" && res.responseMessageOut.body.response.mensaje === "ok") {
      //Oportunidad actualizada con exito
      resul = true;
      status = "SUCESS"
    } else {
      notificaFalloWBS({ body, webService: "Actualiza la oportunidad", response: res.responseMessageOut.body })
    }

    saveBdWebService(idForm, "CRMCreaActualizaOportunidad", { ...body }, status, res.responseMessageOut.body);

    console.timeEnd("inicio");
    return resul;
  } catch (error) {
    console.error("actualizaOportunidad - exception:", error)
    throw error;
  }

}

function* consumeConsultaTicket(action) {

  /*
función que realiza el mapeo y consume el servicio que genera un numero de oportunidad para la afiliacón
*/
  const { items, idFormulario } = action;

  try {
    const body = { itemsForm: items, idFormulario }
    const headers = HEADERS_WS;

    const respues = yield call(axios.post, process.env.REACT_APP_URL_CONSULTA_TICKET_AFILIADO, body, headers);
    //const respues = yield call(axios.post, "http://127.0.0.1:5001/afiliacionempresasprod/us-central1/consumeservicioscrmsirap", request, headers);

    return respues.data;


  } catch (error) {
    console.error(error, "error")
    throw error;
  }
}

function* consumeOportunidad(action) {

  /*
función que realiza el mapeo y consume el servicio que genera un numero de oportunidad para la afiliacón
*/
  const { items } = action;
  const inicio = items.step0.datosinicio;
  const principal = items.stepPrincipal.afiliacionEmpresas;
  const messageid = principal.typeIdCompanyGes + principal.numberIdCompanyGes;
  var date = "";
  var date = new Date();
  const nota = principal.empleadorTypeCompany === "3" ? yield createNotaOportunidad({ items }) : false;

  const ip = yield call(axios.get, 'https://api.ipify.org?format=json');

  const urlConfenalco = process.env.REACT_APP_COMFENALCO_URL_CREATE_UPDATE_OPORTUNIDAD;
  const catalogo = yield select(getCatalogosCargados);
  const ecoActivity = yield generaMacrosector(catalogo.economicActivity, inicio.economicActivityStart);

  var resul = {
    oportunidad: false,
    asesorAsigna: false,
    notEmail: true
  }

  const customer = yield select(getFormularioCustomer);

  let ejecutivoCorporativo = false;
  if (customer.state && ((customer.rol).toLowerCase()).includes("corporativo")) {
    //creado por comercial
    ejecutivoCorporativo = true;
    //resul.idUsuaAsesor = customer.idUsuaAsesor;
  }

  const body = {
    "requestMessageOut": {
      "header": {
        "invokerDateTime": date,
        "moduleId": "OPORTUNIDAD",
        "systemId": "FORMULARIOEMPRESA",
        "messageId": messageid,
        "logginData": {
          "sourceSystemId": "",
          "destinationSystemId": ""
        },
        "destination": {
          "namespace": "http://co/com/comfenalcovalle/esb/ws/CRMCreaActualizaOportunidad",
          "name": "CRMCreaActualizaOportunidad",
          "operation": "execute"
        },
        "securityCredential": {
          "userName": "",
          "userToken": ""
        },
        "classification": {
          "classification": ""
        }
      },
      "body": {
        "request": {
          "oportunidad": {
            "accion": "1",
            "tipoIdentificacionAsesor": ejecutivoCorporativo ? customer.typeId : "",
            "identificacionAsesor": ejecutivoCorporativo ? customer.idAsesor : "",//ejecutivoCorporativo
            "cliente": {
              "tipoPersona": "E",
              "tipoIdentificacion": principal.typeIdCompanyGes,
              "identificacion": principal.numberIdCompanyGes,
              "primerNombre": emptyObject(inicio.employerNameStart).toUpperCase(), //nombre de la empresa
              "email": inicio.emailCompanyStart, //correo de la empresa
              "codSede": inicio.sedeRegional, //regional
              "tamanio": create_tamanio_company(inicio.employedNumberStart), //calcula respecto al numero de empleados
              "canal": "3", //canal virtual
              "tipoSolicitud": principal.empleadorTypeCompany === "3" ? "8" : "1", //natural o juridico 1 y 8 para domestico					
              "fechaNacimiento": "", //matricula mercantil vacia por ahora	
              //todos estos campos vacios
              "barrio": "",
              "direccion": "",
              "nombreContacto": "",
              "genero": "",
              "celular": emptyObject(inicio.smartPhoneRegistro),
              "telefono": "",
              "json": `IP:${emptyObject(ip.data?.ip)}`,
              "nroTrabajadores": emptyObject(inicio.employedNumberStart),
              "macroSector": ecoActivity.macroSector,
              "sector": ecoActivity.sector,
              "subSector": ecoActivity.subSector,
              "actividadEconomica": ecoActivity.actividadEconomica,
            },
            "infoOportunidad": {
              "nombre": "Preafiliacion empleador",// mas tipo y id
              "valor": conversion(emptyObject(inicio.payrollMonthStart)),
              "estado": "2",
              "origen": null,
              "prioridad": null,
              "calificacion": null,
              "servicio": null,
              "categoria": null,
              "unidadVenta": null,
              "canalDistribucion": null,
              "idProducto": null,
              "idFormularioOpor": create_id_oportunidad(principal.empleadorTypeCompany, inicio.sedeRegional),//fuera del valle-1"
              "nota": nota
            }
          }
        }
      }
    }
  }

  try {
    console.time("inicio");
    console.log("body oportunidad", JSON.stringify(body))
    const res = yield consumeServiceGenerico({ body, url: urlConfenalco });
    console.log("response oportunidad", res)
    if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS") {
      resul = {
        oportunidad: res.responseMessageOut.body.response.idOportunidad,
        asesorAsigna: {
          idUsuaAsesor: res.responseMessageOut.body.response.idUsuaAsesor ? res.responseMessageOut.body.response.idUsuaAsesor : "",
          email: res.responseMessageOut.body.response.emailAsesor ? res.responseMessageOut.body.response.emailAsesor?.toLowerCase() : "",
          notEmail: res.responseMessageOut.body.response.emailAsesor ? false : true,
        }
      };

    } else {
      //fallo al crear la oportunidad
      notificaFalloWBS({ body, webService: "Actualiza la oportunidad", response: res.responseMessageOut.body })
    }
    console.timeEnd("inicio");
  } catch (error) {
    console.error(error, "error")
    throw error;
  }
  return resul;
}

function ordenar(a, b) {
  if (a.label > b.label) {
    return 1;
  }
  if (a.label < b.label) {
    return -1;
  }
  return 0;
}

function* onreduxBlur(action) {
  /**
   * Función que captura el evento on redux blur de redux
   * se aplica a cada campo para conocer los cambios del mismo
   */
  const { meta: { field, form }, payload, } = action;

  try {
    let dynamicOptions = {}
    // const formDevuelto = yield select(getFormDevuelto);
    // if (formDevuelto.state !== 0) {
    //   const formInitialited = yield select(getEstadoAfiliacionCompany);
    //   if (formInitialited && payload) {
    //     yield put(devueltaModificacionActive({ state: formDevuelto.state, modified: true }))
    //   }
    // }
    const catalogo = yield select(getCatalogosCargados);
    const infoUser = yield select(getUserInfoComercial);
    const activeFormRya = yield select(getActiveFormRya);

    const idFormulario = yield select(getIdFormulario);
    var newData = {};
    var aux = field.split(".");

    let history = {}
    if (infoUser) {
      history = {
        fechaHistory: new Date(),
        tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
        infoUsuario: infoUser,
        resultadoValidacion: {
          accionRealizada: "Envio postulación a partir de devolución",
          observacion: "Se modifico la información original"
        }
      }
    }


    switch (aux[1]) {

      case "empleadorCajaAsk":
        if (payload === "1")
          yield put(callDinamicDisable({ state: false, field: "empleadorCajaRta" }))

        if (payload === "2")
          yield put(callDinamicDisable({ state: true, field: "empleadorCajaRta" }))
        return;

      case "interseptionType":
        if (payload === "CORR") {
          //yield put(initialize(FORM_NAME_DIRECCION, { datosdireccion: { interseptionType: "CORR", houseTypeCor: "VDA" } }));

          yield put(change(FORM_NAME_DIRECCION, "datosdireccion.houseTypeCor", "VDA"))
        }
        return;

      case "empleadorTypeCompany":
        yield put(change(FORM_NAME_STEP_PRINCIPAL, "afiliacionEmpresas.typeIdCompanyGes", ""))
        newData = {
          disable: false,
          options: catalogo.typeId,
          field: "typeIdCompanyGes",
        };
        if (payload === "1") {
          newData.options = [{ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" }];
        } else {
          newData.options = catalogo.typeId
          yield put(formularioType(payload));
        }
        return yield put(loadDocumentSuccess(newData));

      case "departamentCompany":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["departamentCompany"], payload))
          yield put(change(FORM_NAME_STEP3, field, ""))
        else {
          const depa = idDeparta(catalogo.deptos, payload);
          var citiesP = crearCities(catalogo.cities, depa);
          newData = {
            disable: false,
            options: citiesP.sort(ordenar),
            field: "cityCompany",
          };
          yield put(loadDocumentSuccess(newData));
        }
        return

      case "departamentCompanyAlternate":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["departamentCompanyAlternate"], payload))
          yield put(change(FORM_NAME_STEP3, field, ""))
        else {
          const depa2 = idDeparta(catalogo.deptos, payload)
          var cities = crearCities(catalogo.cities, depa2);
          newData = {
            disable: false,
            options: cities.sort(ordenar),
            field: "cityCompanyAlternate",
          };
          yield put(loadDocumentSuccess(newData));

        }
        return;

      case "cityCompany":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["cityCompany"], payload))
          yield put(change(FORM_NAME_STEP3, field, ""))
        else {
          const cityC = idDeparta(catalogo.cities, payload);
          const barriosC = crearBarrios(catalogo.barrios, cityC);
          newData = {
            disable: false,
            options: barriosC.sort(ordenar),
            field: "hoodCompany",
          };
          yield put(loadDocumentSuccess(newData));
        }
        return;

      case "cityCompanyAlternate":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["cityCompanyAlternate"], payload))
          yield put(change(FORM_NAME_STEP3, field, ""))
        else {
          const cityA = idDeparta(catalogo.cities, payload)
          var barriosA = crearBarrios(catalogo.barrios, cityA);
          newData = {
            disable: false,
            options: barriosA.sort(ordenar),
            field: "hoodCompanyAlternate",
          };
          yield put(loadDocumentSuccess(newData));
        }
        return;

      case "numberId":
        const step4 = yield select(getFormValuesStep4);
        yield put(callDinamicDisableLote([
          { field: "birthDate", state: false },
          { field: "firstLastname", state: false },
          { field: "secondLastname", state: false },
          { field: "firstName", state: false },
          { field: "secondName", state: false },
          { field: "sexo", state: false },
          { field: "smartPhoneBoss", state: false },
          { field: "emailJobBoss", state: false }

        ]));

        if (step4 && step4.datosrepresentante && step4.datosrepresentante?.typeId && payload) {
          const validP = yield validPersonExist({ id: payload, type: step4.datosrepresentante.typeId, campo: "representante" });
          if (validP && validP.exist) {
            //todo Imprime menssage
            yield put(deleteContactsFromValidationStep4({ open: true, message: validP.message, data: { id: payload, type: step4.datosrepresentante.typeId } }));
          } else {
            if (step4.datosrepresentante.typeId === "CC") {
              yield put(openModalCharged(true));

              const resReg = yield consultaAndLockPersonal({ id: step4.datosrepresentante.numberId, tipo: "CC", nuevo: true, type: "repLegal" });
              yield put(openModalCharged(false))

              if (!resReg) {
                //Procesar mensaje dependiento si la empresa esta activa o no 
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(modalInformacionFlujos(
                  {
                    message: yield generateMsgParametrizado(msgParametrizados, "msgNumeroCCErrado"),
                    error: true,
                    open: true,
                  }));

                // yield put(callDinamicDisableLote([
                //   { field: "birthDate", state: true },
                //   { field: "firstLastname", state: true },
                //   { field: "secondLastname", state: true },
                //   { field: "firstName", state: true },
                //   { field: "secondName", state: true },
                //   { field: "sexo", state: true },
                //   { field: "jobBoss", state: true },
                //   { field: "smartPhoneBoss", state: true },
                //   { field: "emailJobBoss", state: true }
                // ]));

              } else if (resReg.servicioAbajo) {
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(modalInformacionFlujos(
                  {
                    message: yield generateMsgParametrizado(msgParametrizados, "msgSerAniNoDisponible"),
                    error: true,
                    open: true,
                  }));

                yield put(callDinamicDisableLote([
                  { field: "birthDate", state: false },
                  { field: "firstLastname", state: false },
                  { field: "secondLastname", state: false },
                  { field: "firstName", state: false },
                  { field: "secondName", state: false },
                  { field: "sexo", state: false },
                  { field: "jobBoss", state: false },
                  { field: "smartPhoneBoss", state: false },
                  { field: "emailJobBoss", state: false }
                ]));

              }

            }
          }


        }
        return;

      case "numberIdStaff":
        const step1 = yield select(getFormValuesStep1);

        yield put(callDinamicDisableLote([
          { field: "birthDateStaff", state: false },
          { field: "firstLastnameStaff", state: false },
          { field: "secondLastnameStaff", state: false },
          { field: "firstNameStaff", state: false },
          { field: "secondNameStaff", state: false },
          { field: "sexoStaff", state: false },
          { field: "jobBossStaff", state: false },
          { field: "smartPhoneBossStaff", state: false },
          { field: "emailStaff", state: false },
        ]));

        if (step1.datospersonaladmin && step1.datospersonaladmin?.typeIdStaff && payload) {
          const validP = yield validPersonExist({ id: payload, type: step1.datospersonaladmin.typeIdStaff, campo: "contacto" });
          if (validP && validP.exist) {
            //todo Imprime menssage
            yield put(change(FORM_NAME_STEP1, field, ""))
            yield put(modalInformacionFlujos(
              {
                message: validP.message,
                error: true,
                open: true,
              }));
          }
          else {
            if (step1.datospersonaladmin?.typeIdStaff === "CC") {
              yield put(openModalCharged(true));

              const resRegPerson = yield consultaAndLockPersonal({ id: step1.datospersonaladmin?.numberIdStaff, tipo: "CC", nuevo: true, type: "contacto" });

              yield put(openModalCharged(false));
              if (!resRegPerson) {
                //Procesar mensaje dependiento si la empresa esta activa o no 
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(modalInformacionFlujos(
                  {
                    message: yield generateMsgParametrizado(msgParametrizados, "msgNumeroCCErrado"),
                    error: true,
                    open: true,
                  }));

                yield put(callDinamicDisableLote([
                  { field: "birthDateStaff", state: true },
                  { field: "firstLastnameStaff", state: true },
                  { field: "secondLastnameStaff", state: true },
                  { field: "firstNameStaff", state: true },
                  { field: "secondNameStaff", state: true },
                  { field: "sexoStaff", state: true },
                  { field: "jobBossStaff", state: true },
                  { field: "smartPhoneBossStaff", state: true },
                  { field: "emailStaff", state: true },
                ]));

              } else if (resRegPerson.servicioAbajo) {
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(modalInformacionFlujos(
                  {
                    message: yield generateMsgParametrizado(msgParametrizados, "msgSerAniNoDisponible"),
                    error: true,
                    open: true,
                  }));

                yield put(callDinamicDisableLote([
                  { field: "birthDateStaff", state: false },
                  { field: "firstLastnameStaff", state: false },
                  { field: "secondLastnameStaff", state: false },
                  { field: "firstNameStaff", state: false },
                  { field: "secondNameStaff", state: false },
                  { field: "sexoStaff", state: false },
                  { field: "jobBossStaff", state: false },
                  { field: "smartPhoneBossStaff", state: false },
                  { field: "emailStaff", state: false },
                ]));

              }
            }
          }
        }

        return;

      case "payrollMonth":
        if (activeFormRya) {
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step2: { datosempleador: { payrollMonth: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación valor nomina mensual";
          saveHistoryEmpresas({ history, idFormulario })
        }
        return;

      case "employedNumber":
        if (activeFormRya) {
          yield put(change(FORM_NAME_STEP0, "datosinicio.employedNumberStart", payload));
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step2: { datosempleador: { employedNumber: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación número de empleados";
          saveHistoryEmpresas({ history, idFormulario })
        }
        return;

      case "employerNameStart":
        if (activeFormRya) {
          yield put(change(FORM_NAME_STEP2, "datosempleador.employerName", payload));
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step0: { datosinicio: { employerNameStart: payload } }, step2: { datosempleador: { employerName: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación de la razon social de la empresa";
          saveHistoryEmpresas({ history, idFormulario })

        }
        return;

      case "economicActivity":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["economicActivity"], payload))
          yield put(change(FORM_NAME_STEP2, field, ""))

        if (activeFormRya) {
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step0: { datosinicio: { economicActivityStart: payload } }, step2: { datosempleador: { economicActivity: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación de la actividad económica empresa";
          saveHistoryEmpresas({ history, idFormulario });
          yield put(change(FORM_NAME_STEP0, "datosinicio.economicActivityStart", payload))
        }
        return;

      case "economicActivityStart":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["economicActivityStart"], payload))
          yield put(change(FORM_NAME_STEP0, field, ""))

        if (activeFormRya) {
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step0: { datosinicio: { economicActivityStart: payload } }, step2: { datosempleador: { economicActivity: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación de la actividad económica empresa";
          saveHistoryEmpresas({ history, idFormulario });
          yield put(change(FORM_NAME_STEP2, "datosempleador.economicActivity", payload))
        }
        return;

      case "jobBossStaff":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["jobBossStaff"], payload))
          yield put(change(FORM_NAME_STEP1, field, ""))
        return;

      case "jobBoss":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["jobBoss"], payload))
          yield put(change(FORM_NAME_STEP4, field, ""))
        return;

      case "hoodCompany":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["hoodCompany"], payload))
          yield put(change(FORM_NAME_STEP3, field, ""))
        return;

      case "hoodCompanyAlternate":
        dynamicOptions = yield select(getDynamicOptions);
        if (!existLabel(dynamicOptions["hoodCompanyAlternate"], payload))
          yield put(change(FORM_NAME_STEP3, field, ""))
        return;

      default:
        return;
    }

  } catch (error) {
    console.error("Function.reduxblur", error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* armarPersona(datos, step, id, sirap, rnec) {
  /*
función que recibe la informacion de la persona que se consulto en registraduria o el validar 
y retorna el json que mapea esta información
*/
  try {
    let persona = false;
    let sexo = ""

    if (sirap) {
      sexo = datos.sexoAfiliado;
      if (step === 4) {
        let dataStep4 = yield select(getFormValuesStep4);
        yield put(validRnecRepLegal(rnec));
        persona = {
          datosrepresentante: {
            rnecBox: rnec,
            typeId: "CC",
            numberId: id,
            firstLastname: emptyObject(datos.primerApellidoAfiliado),
            secondLastname: emptyObject(datos.segundoApellidoAfiliado),
            secondName: emptyObject(datos.segundoNombreAfiliado),
            firstName: emptyObject(datos.primerNombreAfiliado),
            birthDate: (moment(changeFormatDate(datos.fechaNacimientoAfiliado), "DD/MM/YYYY")).toDate(),
            sexo: sexo,
          }
        }
        if (dataStep4 && dataStep4.datosrepresentante) {
          persona.datosrepresentante.jobBoss = emptyObject(dataStep4.datosrepresentante.jobBoss);
          persona.datosrepresentante.emailJobBoss = emptyObject(dataStep4.datosrepresentante.emailJobBoss);
          persona.datosrepresentante.smartPhoneBoss = emptyObject(dataStep4.datosrepresentante.smartPhoneBoss);
        }

      }
      if (step === 2) {
        persona = {
          datospersonaladmin: {
            rnec,
            typeIdStaff: "CC",
            numberIdStaff: id,
            firstLastnameStaff: emptyObject(datos.primerApellidoAfiliado),
            secondLastnameStaff: emptyObject(datos.segundoApellidoAfiliado),
            secondNameStaff: emptyObject(datos.segundoNombreAfiliado),
            firstNameStaff: emptyObject(datos.primerNombreAfiliado),
            birthDateStaff: (moment(changeFormatDate(datos.fechaNacimientoAfiliado), "DD/MM/YYYY")).toDate(),
            sexoStaff: sexo,
          }
        }
      }

    } else {
      if (step === 4) {
        let dataStep4 = yield select(getFormValuesStep4);
        yield put(validRnecRepLegal(rnec));
        persona = {
          datosrepresentante: {
            rnecBox: rnec,
            typeId: "CC",
            numberId: id,
            firstLastname: emptyObject(datos.primerApellido),
            secondLastname: emptyObject(datos.segundoApellido),
            secondName: emptyObject(datos.segundoNombre),
            firstName: emptyObject(datos.primerNombre),
            birthDate: (moment(changeFormatDate(datos.fechaNacimiento), "DD/MM/YYYY")).toDate(),
            sexo: sexo,
          }
        }
        if (dataStep4 && dataStep4.datosrepresentante) {
          persona.datosrepresentante.jobBoss = emptyObject(dataStep4.datosrepresentante.jobBoss);
          persona.datosrepresentante.emailJobBoss = emptyObject(dataStep4.datosrepresentante.emailJobBoss);
          persona.datosrepresentante.smartPhoneBoss = emptyObject(dataStep4.datosrepresentante.smartPhoneBoss);
        }

      }
      if (step === 2) {
        persona = {
          datospersonaladmin: {
            rnec,
            typeIdStaff: "CC",
            numberIdStaff: id,
            firstLastnameStaff: emptyObject(datos.primerApellido),
            secondLastnameStaff: emptyObject(datos.segundoApellido),
            secondNameStaff: emptyObject(datos.segundoNombre),
            firstNameStaff: emptyObject(datos.primerNombre),
            birthDateStaff: (moment(changeFormatDate(datos.fechaNacimiento), "DD/MM/YYYY")).toDate(),
            sexoStaff: sexo,
          }
        }
      }

    }


    return persona;
  } catch (error) {
    console.error("Function.armarPersona", error);
    throw error;
  }
}

function idDeparta(catalogo, id) {
  var idDepa = id
  catalogo.forEach(element => {
    if ((element.label) === (id)) {
      idDepa = element.value;
    }
  });
  return idDepa;
}

function* onReduxChange(action) {
  const { meta: { field, form }, payload, } = action;

  try {
    const infoUser = yield select(getUserInfoComercial);
    const idFormulario = yield select(getIdFormulario);
    const activeFormRya = yield select(getActiveFormRya)

    let history = {}
    if (infoUser) {
      history = {
        fechaHistory: new Date(),
        tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
        infoUsuario: infoUser,
        resultadoValidacion: {
          accionRealizada: "Modificacion campo desde bandeja",
          observacion: `Se modifico la información original, con el siguiente dato : ${payload}`
        }
      }
    }

    var newData = {};
    var aux = field.split(".");
    switch (aux[1]) {
      case "interseptionType":
        let openCorr = false;
        if (payload === "CORR") {
          openCorr = true;
        }
        return yield put(changeCorregimientoForm(openCorr));

      case "empleadorTypeCompany":
        yield put(change(FORM_NAME_STEP_PRINCIPAL, "afiliacionEmpresas.typeIdCompanyGes", ""));
        return yield put(change(FORM_NAME_STEP_PRINCIPAL, "afiliacionEmpresas.numberIdCompanyGes", ""));

      case "typeIdCompanyGes":
        if (payload === "PA" || payload === "PT" || payload === "PE")
          yield put(changeComponentId({ field: "numberIdCompanyGes", type: "text" }));
        else
          yield put(changeComponentId({ field: "numberIdCompanyGes", type: "number" }));

        return yield put(change(FORM_NAME_STEP_PRINCIPAL, "afiliacionEmpresas.numberIdCompanyGes", ""));

      case "typeId":
        if (payload === "PA" || payload === "PT" || payload === "PE")
          yield put(changeComponentId({ field: "numberId", type: "text" }));
        else
          yield put(changeComponentId({ field: "numberId", type: "number" }));
        return;

      case "typeIdStaff":
        if (payload === "PA" || payload === "PT" || payload === "PE")
          yield put(changeComponentId({ field: "numberIdStaff", type: "text" }));
        else
          yield put(changeComponentId({ field: "numberIdStaff", type: "number" }));
        return;

      case "startOperation":
        if (activeFormRya) {
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step2: { datosempleador: { startOperation: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación fecha de inicio de operación";
          saveHistoryEmpresas({ history, idFormulario })
        }
        return;

      case "contributionPeriod":
        if (activeFormRya) {
          yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step2: { datosempleador: { contributionPeriod: payload } }, date: history.fechaHistory }, { merge: true });
          history.resultadoValidacion.accionRealizada = "Modificación fecha del primer periodo de aportes";
          saveHistoryEmpresas({ history, idFormulario })
        }
        return;

      default:
        return;
    }

  } catch (error) {
    console.error("Function.onReduxChange", error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }

}

function crearCities(citys, idDepto) {
  var arrCitys = [];
  citys.forEach((element) => {
    if (element.id_depa === idDepto) {
      arrCitys.push({
        label: element.label,
        value: element.value,
      });
    }
  });
  return arrCitys;
}

const crearBarrios = (barrios, idCity) => {

  var arrBarrios = [];
  barrios.forEach((element) => {
    if (element.idmuni === idCity) {
      arrBarrios.push({
        label: element.label,
        value: element.value,
      });
    }
  });

  return arrBarrios;
}

function* grabarEnBD(action) {

  const url = "https://us-central1-comfenalco-valle-firebase-lab.cloudfunctions.net/downloadCatalog";
  const url3 = "https://us-central1-comfenalco-valle-firebase-prod.cloudfunctions.net/downloadCatalog"
  const url2 = "http://localhost:5001/comfenalco-valle-firebase-prod/us-central1/downloadCatalog"

  const headers = HEADERS_WS;
  try {
    for (var element of action) {
      var body = { body: { data: element.data, name: element.name } }
      yield call(axios.post, url3, body, headers);
    }
  } catch (error) {
    console.error(error)
  }


}

function* enviarEmail(action) {
  try {
    const { idFormulario, email } = action
    const url = process.env.REACT_APP_URL_SEND_EMAIL;
    const urlEmpresas = `https://${process.env.REACT_APP_FIREBASE_PROJECT_ID}.web.app/empresas`;

    const headers = HEADERS_WS;
    let body = {
      from: "Notificaciones afiliación empleador por primera vez",
      to: `<${email}>`,
      subject: "Notificación de inscripción de empresa",
      message: `<div><p>Con el siguiente numero de proceso: <b>${idFormulario}</b> se ha registrado su empresa.</p><p>Podrás continuar con el diligenaciamiento de los datos en el formulario de afiliación ingresando los datos de su empresa y el numero de proceso, a traves del siguiente enlace: <a href=${urlEmpresas}>Retomar postulación</a></p><p>cordialmente</p> <p>Comfenalco Valle dela Gente</p></div>`
    }

    enviarEmailFormatDocument({ from: "Notificaciones afiliación empleador por primera vez", to: email, subject: "Notificación de inscripción de empresa", type: "OPORTUNIDAD", oportunidad: idFormulario });

    const respues = yield call(axios.post, url, body, headers);
    return respues;
  } catch (error) {
    console.error("Function.enviarEmail", error);
    throw error;
  }
}


function* enviarBarcode(action) {
  try {
    const { idFormulario } = action;
    const url = process.env.REACT_APP_URL_SEND_BARCODE;

    let body = { idFormulario }
    const headers = HEADERS_WS;
    const respues = yield call(axios.post, url, body, headers);
    return respues;
  } catch (error) {
    console.error("Function.enviarBarcode", error);
    throw `Function.enviarBarcode - saga.js- ${error}`;
  }

}

function* migrarCatalogo(action) {
  try {
    const { catalog } = action;
    //const url = "https://migrarcatalogo-gub3ser6oa-uc.a.run.app"; //proyecto TEST
    const url = "https://migrarcatalogo-gsvv456pfa-uc.a.run.app"; // proyecto pruebas

    let body = { catalogo: catalog }
    const headers = HEADERS_WS;
    const respues = yield call(axios.post, url, body, headers);
    return respues;
  } catch (error) {
    console.error("Function.enviarBarcode", error);
  }

}

function* consumeServiceGenerico(action) {
  try {
    const { body, url } = action;


    const request = { urlServicio: url, body: body }
    const headers = HEADERS_WS;

    const respues = yield call(axios.post, process.env.REACT_APP_FIREBASE_SEND_CONSUME_SERVICIOS_GENERICOS, request, headers);
    //const respues = yield call(axios.post, "http://127.0.0.1:5001/afiliacionempresasprod/us-central1/consumeservicioscrmsirap", request, headers);

    return respues.data;
  } catch (error) {
    console.error("Function.consumeServiceGenerico", error);
    throw `Function.consumeServiceGenerico - saga.js -${error}`;
  }


}

function* generateMsgParametrizado(catalog, clave) {
  try {
    const message = yield consultaMsgParametrizado(catalog, clave);
    yield put(updateMsgSolicitud(message));
    return message.text;
  } catch (error) {
    throw error;
  }
}


function* validaAfiliacionCompany(action) {
  /*
función que valida si hay un registro en bd de los datos suministrados en el inicio
si  la hay solicita ingresar o informa que la afiliación se esta validando
si no hay verifica que la empresa no este afiliada ya y procede a empeza el proceso de ser posible
*/
  // yield createCatalog()

  //yield createConversion()

  try {

    const items = yield select(getFormValuesStepPricipal)
    let valido = yield validateStepPrincipal({ items });
    if (valido.valid) {
      yield put(openModalCharged(true));
      yield put(savedEmpleadorType(items.afiliacionEmpresas?.empleadorTypeCompany))
      const id = items.afiliacionEmpresas?.numberIdCompanyGes;
      const tipo = items.afiliacionEmpresas?.typeIdCompanyGes;
      const idUser = items.afiliacionEmpresas?.numberIdCompanyGes;
      yield put(saveIdUser(items.afiliacionEmpresas.numberIdCompanyGes));
      let solicitudes = false;
      let idFormulario = false;

      yield put(saveIdUser(items.afiliacionEmpresas.numberIdCompanyGes));
      yield firebaseDatabase.collection("solicitudesEmpresas")
        .where('iduser', '==', idUser)
        .where('state', 'not-in', [estados.ANULADA, estados.AFILIADA])
        .get().then(docs => {
          docs.forEach(doc => {
            if (doc.data()) {
              solicitudes = doc.data();
              idFormulario = doc.id;
            }
          });
        });

      if (solicitudes) {
        if (solicitudes.state !== estados.BORRADOR && solicitudes.state !== estados.DEVUELTA) {
          yield put(openModalNumProcess(false));
          //ya hay una postulacion en curso con ese documento
          yield put(openModalCharged(false))
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgSolicitudEnProceso"),
              error: true,
              open: true,
            }));
        } else {
          if (solicitudes.state === estados.DEVUELTA)
            yield put(devueltaModificacionActive({ state: estados.DEVUELTA, modified: solicitudes.devueltoAndModified ? solicitudes.devueltoAndModified : false }))
          yield put(saveIdFormulario(idFormulario));
          yield put(openModalCharged(false))
          yield put(openModalNumProcess(true));
          yield put(savedSolicitudes({ ...solicitudes }))
        }

        if (solicitudes.step1 && solicitudes.step1.datospersonaladmin) {

          yield put(savePersonalAdmin({ data: [...solicitudes.step1.datospersonaladmin] }))

        }

      } else {
        yield put(createUserPerson({
          id: id,
          tipoId: tipo,
          rol: "Empresa"
        }))
        const conEmpresa = yield consumeConsultaEmpresas({ id, tipo })
        if (conEmpresa === false) {
          //inicializando  tipo y numero id de la empresa
          let step0 = { datosinicio: {} }
          const catalogo = yield select(getCatalogosCargados);
          const newData = {
            disable: false,
            options: catalogo.typeId,
            field: "typeIdCompanyStart",
          };

          //iniciar consulta rues 


          if (items.afiliacionEmpresas.empleadorTypeCompany === "1") {
            newData.options = [{ label: "Número de identificación tributaria", value: "NI", id_tiid: "3" }];
          }
          yield put(loadDocumentSuccess(newData));

          step0.datosinicio.typeIdCompanyStart = items.afiliacionEmpresas?.typeIdCompanyGes;
          step0.datosinicio.checkNumberStart = items.afiliacionEmpresas?.numberIdCompanyGes;

          yield put(initialize(FORM_NAME_STEP0, step0));
          const mapRues = false;//yield consumeMapeoRues({ id: id, tipoId: tipo, typeEmpleador: items.afiliacionEmpresas.empleadorTypeCompany });
          //yield put(initialize(FORM_NAME_STEP0, mapRues.step0));
          console.log(mapRues);
          yield put(saveMapeoRuesSuccess(mapRues));
          let successReg = true;
          if (items.afiliacionEmpresas.empleadorTypeCompany === "3") {

            if (tipo === "CC")
              successReg = yield consultaAndLockPersonal({ id, tipo, nuevo: true, type: "repLegal", inicio: true });
            else successReg = mapRues;
            yield put(callDinamicDisable({ field: "economicActivityStart", state: true }));
            yield put(change(FORM_NAME_STEP0, "datosinicio.economicActivityStart", "9700 - Actividades de los hogares individuales como empleadores de personal domestico."))
            yield put(callDinamicDisable({ field: "companyClass", state: true }));
            yield put(change(FORM_NAME_STEP2, "datosempleador.companyClass", "2"));

          }

          if (items.afiliacionEmpresas.empleadorTypeCompany === "2") {
            yield put(callDinamicDisable({ field: "companyClass", state: true }));
            yield put(change(FORM_NAME_STEP2, "datosempleador.companyClass", "2"));
            if (tipo === "CC") {
              successReg = yield consultaAndLockPersonal({ id, tipo, nuevo: true, type: "repLegal", inicio: true });
            } else successReg = true;
          }

          if (items.afiliacionEmpresas.empleadorTypeCompany === "1") {
            yield put(callDinamicDisable({ field: "companyClass", state: false }));
          }

          if (items.afiliacionEmpresas.empleadorTypeCompany !== "1" && tipo !== "CC") {
            //inicializar tipo y numero de identificacion para natural y domesticas
            yield put(callDinamicDisable({ field: "numberId", state: true }));
            yield put(change(FORM_NAME_STEP4, "datosrepresentante.numberId", items.afiliacionEmpresas.numberIdCompanyGes));

            yield put(callDinamicDisable({ field: "typeId", state: true }));
            yield put(change(FORM_NAME_STEP4, "datosrepresentante.typeId", tipo));
            yield put(callDinamicDisable({ field: "employerNameStart", state: false }));
          }
          //llenar los anexos requeridos


          if (items.afiliacionEmpresas.empleadorTypeCompany !== "1" && successReg !== true) {
            if (!successReg) {
              yield put(openModalCharged(false))
              yield put(openModalNumProcess(false));
              //Procesar mensaje dependiento si la empresa esta activa o no 
              const msgParametrizados = yield select(getMsgParametrizados);
              yield put(modalInformacionFlujos(
                {
                  message: yield generateMsgParametrizado(msgParametrizados, "msgNumeroCCErrado"),
                  error: true,
                  open: true,
                }));

            } else if (successReg.servicioAbajo) {
              yield put(openModalCharged(false))
              //yield put(openModalNumProcess(false));
              //ingresa los datos manualmente
              yield put(dataPantallaInicio(items));
              yield put(estadoAfiliacionCompany(true));
              const msgParametrizados = yield select(getMsgParametrizados);
              yield put(modalInformacionFlujos(
                {
                  message: yield generateMsgParametrizado(msgParametrizados, "msgSerAniNoDisponible"),
                  error: true,
                  open: true,
                }));

              yield put(callDinamicDisableLote([
                { field: "birthDate", state: false },
                { field: "firstLastname", state: false },
                { field: "secondLastname", state: false },
                { field: "firstName", state: false },
                { field: "secondName", state: false },
                { field: "sexo", state: false },
                { field: "jobBoss", state: false },
                { field: "smartPhoneBoss", state: false },
                { field: "emailJobBoss", state: false }
              ]));

            }
          } else {
            console.log("entroe")
            yield put(change(FORM_NAME_STEP2, "datosempleador.digitNumber", `${calcularDigitoVerificacion(id)}`));

            yield put(dataPantallaInicio(items));
            yield put(estadoAfiliacionCompany(true));

            yield put(openModalCharged(false));
          }

        } else {
          yield put(openModalNumProcess(false));
          //Procesar mensaje dependiento si la empresa esta activa o no 
          let clave = "msgEmpresaRegistradaSirapInactiva"
          if (conEmpresa && conEmpresa.activoEmpresa === "S")
            clave = "msgEmpresaRegistradaSirapActiva";
          yield put(openModalCharged(false))
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, clave),
              error: true,
              open: true,
            }));
        }
      }
    } else {
      yield put(modalInformacionFlujos(
        {
          message: valido.campo,
          error: true,
          open: true,
        }));
    }

  } catch (error) {
    console.error(error)
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* consultaAndLockPersonal(action) {
  /*
función consulta una persona con tipo de identificación CC
y al resultar exitoso carga en la postulación dicha información
*/
  try {
    console.log(action);
    const { tipo, id, nuevo, type, inicio, rues } = action;

    const empleadorType = yield select(getEmpleadorType)


    const persona = yield consultaPersona({ tipo, id });

    let personaArm = "";
    let disables = [

      { field: "birthDate", state: true },
      { field: "firstLastname", state: true },
      { field: "secondLastname", state: true },
      { field: "firstName", state: true },
      { field: "secondName", state: true },


    ]

    let step = 4;

    if (type === "contacto") {
      step = 2;
      disables = [

        { field: "birthDateStaff", state: true },
        { field: "firstLastnameStaff", state: true },
        { field: "secondLastnameStaff", state: true },
        { field: "firstNameStaff", state: true },
        { field: "secondNameStaff", state: true },
      ]
    }

    let success = false;

    if (persona && persona.data) {
      success = true;
      if (persona.registraduria && persona.data.Data.return.datosCedulas && persona.data.Data.return.datosCedulas.estadoCedula.includes("Vigente")) {

        if (nuevo) {
          personaArm = yield armarPersona(persona.data.Data.return.datosCedulas, step, id, false, true)
        }

        let dataRnec = { ...persona.data.Data.return.datosCedulas };
        dataRnec.estadoValidacion = "1"
        dataRnec.fechaValidacion = persona.data.Data.return.estadoConsulta.fechaHoraConsulta.split(" ")[0];

        if (type === "contacto") {
          //guardando datos cedulas completos
          let dataRnecActual = yield select(getDatosConsultaRnec);
          const dataFilter = yield filterDataRnec(yield select(getPersonalAdmin), dataRnec, dataRnecActual.contacto)
          yield put(saveDatosCedulasRnec({ type: "contacto", data: dataFilter }));
        } else {
          yield put(saveDatosCedulasRnec({ type: "representante", data: dataRnec }));
        }

        if (!inicio) {
          const msgParametrizados = yield select(getMsgParametrizados);

          yield put(modalInformacionFlujos(
            {
              message: rues ? yield generateMsgParametrizado(msgParametrizados, "msgValidaAniSuccessRues") : yield generateMsgParametrizado(msgParametrizados, "msgValidaAniSuccess"),
              error: false,
              open: true,
            }));
        }
        yield put(callDinamicDisableLote(disables));
      } else if (persona.data) {

        if (nuevo) {
          personaArm = yield armarPersona(persona.data, step, id, true, persona.sirap ? true : false);
        }

        if (step === 4 && personaArm.datosrepresentante?.sexo)
          disables.push({ field: "sexo", state: true })

        if (step === 2 && personaArm.datospersonaladmin?.sexoStaff)
          disables.push({ field: "sexoStaff", state: true })

        yield put(callDinamicDisableLote(disables));
      }


      if (step === 4) {

        yield put(initialize(FORM_NAME_STEP4, personaArm));
      }
      if (step === 2) {
        yield put(initialize(FORM_NAME_STEP1, personaArm));
      }

      if (empleadorType !== "1") {
        if (step === 4) {
          let dataInicio = yield select(getFormValuesStep0);

          if (dataInicio && dataInicio.datosinicio)
            dataInicio.datosinicio.employerNameStart = (`${personaArm.datosrepresentante?.firstLastname} ${personaArm.datosrepresentante?.secondLastname} ${personaArm.datosrepresentante?.firstName} ${personaArm.datosrepresentante?.secondName}`).replaceAll("  ", " ");
          else
            dataInicio = {
              datosinicio: {
                employerNameStart: (`${personaArm.datosrepresentante?.firstLastname} ${personaArm.datosrepresentante?.secondLastname} ${personaArm.datosrepresentante?.firstName} ${personaArm.datosrepresentante?.secondName}`).replaceAll("  ", " ")
              }
            }
          console.log(personaArm, dataInicio)
          yield put(initialize(FORM_NAME_STEP0, dataInicio));
        }


        yield put(callDinamicDisableLote([
          { field: "typeId", state: true },
          { field: "numberId", state: true },
          //{ field: "employerNameStart", state: true },
        ]));

      }

    } else {
      let dataStep4 = yield select(getFormValuesStep4);
      if (nuevo) {

        if (step === 4) {
          personaArm = {
            datosrepresentante: {
              rnecBox: false,
              typeId: tipo,
              numberId: persona.servicioAbajo ? id : "",
            }
          }

          if (dataStep4 && dataStep4.datosrepresentante && dataStep4.datosrepresentante.jobBoss)
            personaArm.datosrepresentante.jobBoss = dataStep4.datosrepresentante.jobBoss;

          if (dataStep4 && dataStep4.datosrepresentante && dataStep4.datosrepresentante.emailJobBoss)
            personaArm.datosrepresentante.emailJobBoss = dataStep4.datosrepresentante.emailJobBoss;
          yield put(initialize(FORM_NAME_STEP4, personaArm));
        }
        else {
          personaArm = {
            datospersonaladmin: {
              rnec: false,
              typeIdStaff: tipo,
              numberIdStaff: persona.servicioAbajo ? id : "",
            }
          }
          yield put(initialize(FORM_NAME_STEP1, personaArm));
        }
      }
      if (persona.servicioAbajo) {
        success = {
          servicioAbajo: true,
        }

      }
    }

    if (empleadorType !== "1") {

      yield put(callDinamicDisableLote([

        { field: "typeId", state: true },
        { field: "numberId", state: true },
      ]));

    }

    if (persona.registraduria && nuevo && success) {
      const msgParametrizados = yield select(getMsgParametrizados);
      yield put(modalInformacionFlujos(
        {
          message: rues ? yield generateMsgParametrizado(msgParametrizados, "msgValidaAniSuccessRues") : yield generateMsgParametrizado(msgParametrizados, "msgValidaAniSuccess"),
          error: false,
          open: true,
        }));
    }

    return success;
  } catch (error) {
    console.error(error)
    throw `consultaAndLockPersonal.js - Error: ${error}`
  }
}

function* gestionPersonalAdmin(action) {
  /*
función que realiza las acciones correspondientes a la información de contacto de la afiliacion, limpia, eliminar o agregar 
*/
  const { value } = action;
  // console.log(action)
  try {
    yield put(openModalCharged(true));
    if (value && value.field?.placeholder) {
      const placeholder = value.field.placeholder;
      const formRya = yield select(getActiveFormRya);
      if (placeholder && (placeholder.includes("Adicionar") || placeholder.includes("Actualizar"))) {

        //yield put(change(FORM_NAME_STEP1, "datospersonaladmin.jobBossStaff", ""));
        let items = yield select(getFormValuesStep1);
        if (items) {
          const valid = yield validateStep1(items);
          if (valid.valid) {
            const pos = yield select(getEditEnabled);
            const tablePersonal = yield select(getTableDataPersonal);
            // console.log(tablePersonal)
            if ((tablePersonal.length >= 3 && pos === false) && placeholder.includes("Adicionar")) {
              //maximos permitidos de contactos
              yield put(cleanAutoComplete())
              yield put(callDinamicDisableLote([
                { field: "birthDateStaff", state: false },
                { field: "firstLastnameStaff", state: false },
                { field: "secondLastnameStaff", state: false },
                { field: "firstNameStaff", state: false },
                { field: "secondNameStaff", state: false },
              ]));
              yield put(initialize(FORM_NAME_STEP1, {}))

              const msgParametrizados = yield select(getMsgParametrizados);
              yield put(modalInformacionFlujos(
                {
                  message: yield generateMsgParametrizado(msgParametrizados, "msgMaximoRegistraContactos"),
                  error: true,
                  open: true,
                }));
            } else {

              yield put(cleanAutoComplete())
              yield put(callDinamicDisableLote([
                { field: "birthDateStaff", state: false },
                { field: "firstLastnameStaff", state: false },
                { field: "secondLastnameStaff", state: false },
                { field: "firstNameStaff", state: false },
                { field: "secondNameStaff", state: false },
              ]));
              yield put(initialize(FORM_NAME_STEP1, {}))

              let aux = items.datospersonaladmin;
              aux.firstLastnameStaff = emptyObject(aux.firstLastnameStaff).toUpperCase();
              aux.secondLastnameStaff = emptyObject(aux.secondLastnameStaff).toUpperCase();
              aux.firstNameStaff = emptyObject(aux.firstNameStaff).toUpperCase();
              aux.secondNameStaff = emptyObject(aux.secondNameStaff).toUpperCase();
              items.datospersonaladmin = { ...aux }


              let tableTemp = [];
              console.log(pos, placeholder)
              if (placeholder.includes("Adicionar") && pos === false) {
                tableTemp = [...tablePersonal]
                tableTemp.push(items.datospersonaladmin);

              } else {
                yield put(editingEnabledContact(false));
                if (tablePersonal.length > 0) {
                  tablePersonal.forEach((item, i) => {
                    if (i === pos) {

                      tableTemp.push(items.datospersonaladmin)
                    } else {
                      tableTemp.push(item)
                    }

                  });
                } else {
                  tableTemp.push(items.datospersonaladmin)
                }

                if (formRya) {
                  const idFormulario = yield select(getIdFormulario);
                  yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ step1: { datospersonaladmin: tableTemp }, soportRnec: true }, { merge: true });

                  yield put(activateSoportRnec(true));

                  let infoUser = yield select(getUserInfoComercial);
                  if (!infoUser)
                    infoUser = yield select(getUserPersona);

                  const history = {
                    fechaHistory: new Date(),
                    tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
                    infoUsuario: infoUser,
                    resultadoValidacion: {
                      accionRealizada: "Contacto editado desde la bandeja",
                      observacion: `Se modificó la información de uno de los contactos en la lista, por asesor`,
                    }
                  }

                  saveHistoryEmpresas({ history, idFormulario });
                }
              }

              let newData = {
                disable: false,
                options: [],
                field: "tablePersonal",
              };

              tableTemp.forEach(items => {
                newData.options.push([
                  { rnec: emptyObject(items.rnec) },
                  { label: emptyObject(items.typeIdStaff) },
                  { label: emptyObject(items.numberIdStaff) },
                  { label: emptyObject(items.firstLastnameStaff).toUpperCase() },
                  { label: emptyObject(items.secondLastnameStaff).toUpperCase() },
                  { label: emptyObject(items.firstNameStaff).toUpperCase() },
                  { label: emptyObject(items.secondNameStaff).toUpperCase() },
                  { label: emptyObject(items.jobBossStaff) },
                  { label: emptyObject(items.emailStaff) },
                ])
              });

              yield put(loadDocumentSuccess(newData));
              yield put(saveDataTablePersonal([...tableTemp]));
            }
          } else {
            yield put(modalInformacionFlujos(
              {
                message: valid.campo,
                error: true,
                open: true,
              }));
          }
        } else {
          yield put(modalInformacionFlujos(
            {
              message: "Por favor ingresar los campos requeridos",
              error: true,
              open: true,
            }));
        }

        if (formRya) yield put(initEditarFromBandeja(false))
      }
      if (placeholder && placeholder.includes("Limpiar")) {
        yield put(cleanAutoComplete())
        yield put(callDinamicDisableLote([
          { field: "birthDateStaff", state: false },
          { field: "firstLastnameStaff", state: false },
          { field: "secondLastnameStaff", state: false },
          { field: "firstNameStaff", state: false },
          { field: "secondNameStaff", state: false },
        ]));
        yield put(initialize(FORM_NAME_STEP1, {}))
      }

      if (placeholder && placeholder.includes("Eliminar")) {

        const { value: { row } } = action;
        let tablePersonal = yield select(getTableDataPersonal);
        let newData = {
          disable: false,
          options: [],
          field: "tablePersonal",
        };
        let tableNew = []
        tablePersonal.forEach(items => {
          if (!(items.numberIdStaff === row[2].label && items.typeIdStaff === row[1].label)) {
            newData.options.push([
              { rnec: emptyObject(items.rnec) },
              { label: emptyObject(items.typeIdStaff) },
              { label: emptyObject(items.numberIdStaff) },
              { label: emptyObject(items.firstLastnameStaff) },
              { label: emptyObject(items.secondLastnameStaff) },
              { label: emptyObject(items.firstNameStaff) },
              { label: emptyObject(items.secondNameStaff) },
              { label: emptyObject(items.jobBossStaff) },
              { label: emptyObject(items.emailStaff) },
            ]);
            tableNew.push(items);
          }

        });
        yield put(loadDocumentSuccess(newData));
        yield put(saveDataTablePersonal(tableNew));
      }

      if (placeholder && placeholder.includes("Editar")) {
        const { value: { row, position } } = action;

        //saber si estoy desde la bandeja


        if (formRya) yield put(initEditarFromBandeja(true))

        let tablePersonal = yield select(getTableDataPersonal);
        yield put(editingEnabledContact(position));

        let dataEdit = {}

        tablePersonal.forEach(items => {
          if ((items.numberIdStaff === row[2].label && items.typeIdStaff === row[1].label)) {
            dataEdit = {
              datospersonaladmin: items
            }            //   {
            //     typeIdStaff=items.typeIdStaff,
            //     numberIdStaff=items.numberIdStaff,
            //     firstLastnameStaff=items.firstLastnameStaff,
            //     secondLastnameStaff=items.secondLastnameStaff,
            //     firstNameStaff=items.firstNameStaff,
            //     secondNameStaff
            //   }
            //   { label: emptyObject(items.typeIdStaff) },
            // { label: emptyObject(items.numberIdStaff) },
            // { label: emptyObject(items.firstLastnameStaff) },
            // { label: emptyObject(items.secondLastnameStaff) },
            // { label: emptyObject(items.firstNameStaff) },
            // { label: emptyObject(items.secondNameStaff) },
            // { label: emptyObject(items.jobBossStaff) },
            // { label: emptyObject(items.emailStaff) },


          }

        });
        //pendiente convertir fecha al formato

        dataEdit.datospersonaladmin.birthDateStaff = new Date(getFechaOfDateRya(dataEdit.datospersonaladmin.birthDateStaff));

        yield put(initialize(FORM_NAME_STEP1, dataEdit))
      }

    } else {
      yield put(cleanAutoComplete())
      yield put(callDinamicDisableLote([
        { field: "birthDateStaff", state: false },
        { field: "firstLastnameStaff", state: false },
        { field: "secondLastnameStaff", state: false },
        { field: "firstNameStaff", state: false },
        { field: "secondNameStaff", state: false },
      ]));
      yield put(initialize(FORM_NAME_STEP1, {}))
    }
    yield put(openModalCharged(false));
  } catch (error) {
    console.error(`gestionPersonalAdmin - saja.js : ${error}`);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* validateForm(action) {
  /*
función que recibe la información del formulario y se encarga de las validaciones de datos correspondientes
*/
  const { step0, step2, step3, step4, step1, step5 } = action

  try {

    const empleadorType = yield select(getEmpleadorType)
    let va = yield select(getActiveStep);
    va = empleadorType === "3" && va > 0 ? va + 1 : va;
    var valid = true;
    let campo = "Por favor ingresar los campos requeridos marcados con ( * )";
    const requiredStep0 = REQUIRED_FORM_STEP0;
    const requiredStep2 = REQUIRED_FORM_STEP2;
    const requiredStep2_dome = REQUIRED_FORM_STEP2_DOMES;
    const requiredStep3 = REQUIRED_FORM_STEP3;
    const requiredStep4 = REQUIRED_FORM_STEP4;
    const catalog = yield select(getDynamicOptions);


    if (va === 0) {
      if (step0?.datosinicio) {
        var ban2 = false;
        campo = 'Por favor ingresar los campos requeridos: sección "Inscripción" campos: (';
        requiredStep0.forEach(element => {
          if (!step0.datosinicio[element.value]) {
            valid = false;
            campo = campo + " " + element.label + ",";
          }
        });

        if (
          step0.datosinicio &&
          step0.datosinicio["emailCompanyStart"] &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
            step0.datosinicio["emailCompanyStart"]
          )
        ) {
          valid = false;
          campo = campo + " Correo con formato no valido,";
        }

        if (
          step0.datosinicio &&
          step0.datosinicio["emailCompanyCheckStart"] &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
            step0.datosinicio["emailCompanyCheckStart"]
          )
        ) {
          valid = false;
          campo = campo + " Confirma correo con formato no valido,";
        }

        if (
          step0.datosinicio &&
          step0.datosinicio["emailCompanyCheckStart"] && step0.datosinicio["emailCompanyStart"]
          && step0.datosinicio["emailCompanyCheckStart"] !== step0.datosinicio["emailCompanyStart"]) {
          valid = false;
          campo = campo + " Los correos no coinciden,";
        }
        if (step0.datosinicio["smartPhoneRegistro"] && step0.datosinicio["smartPhoneRegistro"].length < 10) {
          valid = false;
          campo = campo + " la longitud del celular debe ser de 10 digitos,";
        }

        if (step0.datosinicio && step0.datosinicio.economicActivityStart && step0.datosinicio.economicActivityStart.length > 2) {
          const ban = catalog.economicActivity.find(e => e.label.toUpperCase() === step0.datosinicio.economicActivityStart.toUpperCase());
          if (!(ban && ban.value)) {
            valid = false;
            campo = campo + " Actividad económica, debe seleccionar una de la lista";
          }
        }

      } else {
        valid = false;
      }

    }

    if (va === 2) {
      if (step2?.datosempleador) {
        var ban2 = false;
        campo = 'Por favor ingresar los campos requeridos: sección "Información del empleador" campos: (';
        if (empleadorType && empleadorType === "3") {
          requiredStep2_dome.forEach(element => {
            if (!step2.datosempleador[element.value]) {
              valid = false;
              campo = campo + " " + element.label + ",";
            }
          });
        } else {
          requiredStep2.forEach(element => {
            if (!step2.datosempleador[element.value]) {
              valid = false;
              campo = campo + " " + element.label + ",";
            }
          });
        }

      } else {
        valid = false;
      }

      if (step2.ubicacionempleadorask) {
        if (!step2.ubicacionempleadorask["empleadorCajaAsk"]) {
          valid = false;
          campo = campo + " Estuvo o está afiliado como empleador,";
        }
        if (step2.ubicacionempleadorask["empleadorCajaAsk"] && step2.ubicacionempleadorask["empleadorCajaAsk"] === "1") {
          if (!step2.ubicacionempleadorask["empleadorCajaRta"]) {
            valid = false;
            campo = campo + " Nombre Caja Anterior";

          }
        }

        if (step2.datosempleador && step2.datosempleador.economicActivity && step2.datosempleador.economicActivity.length > 2) {
          const ban = catalog.economicActivity.find(e => e.label.toUpperCase() === step2.datosempleador.economicActivity.toUpperCase());
          if (!(ban && ban.value)) {
            valid = false;
            campo = campo + " Debe seleccionar una actividad económica de la lista";
          }
        }

      } else {
        campo = campo + " marcados con * de todas las secciones )";
        valid = false;
      }

    }

    if (va === 3) {

      if (step3?.ubicacionempleador) {
        var ban2 = false;
        campo = 'Por favor ingresar los campos requeridos: sección "Ubicación del empleador" campos: (';
        requiredStep3.forEach(element => {
          if (!step3.ubicacionempleador[element.value]) {
            valid = false;
            campo = campo + " " + element.label + ",";
          }
        });

        if (step3.ubicacionempleador && step3.ubicacionempleador.hoodCompany) {
          const ban = catalog.hoodCompany.find(e => e.label.toUpperCase() === step3.ubicacionempleador.hoodCompany.toUpperCase());
          if (!(ban && ban.value)) {
            valid = false;
            campo = campo + " Barrio empresa, debe seleccionar uno de la lista,";
          }
        }

      } else {
        valid = false;
      }

      if (!emptyJson(step3.ubicacionempleadoraltern)) {
        let isCampo = false;
        campo = 'Por favor ingresar los campos requeridos: sección "Ubicación alterna del empleador" campos: (';
        REQUIRED_FORM_STEP3_ALTERN.forEach((field) => {
          if (step3.ubicacionempleadoraltern[field.value] && step3.ubicacionempleadoraltern[field.value].length > 0) {
            isCampo = true;
          }
        });
        if (isCampo) {
          REQUIRED_FORM_STEP3_ALTERN.forEach((field) => {
            if (!(step3.ubicacionempleadoraltern[field.value] && step3.ubicacionempleadoraltern[field.value].length > 0)) {
              valid = false;
              campo = campo + " " + field.label + ",";
            }
          });

          if (step3.ubicacionempleadoraltern && step3.ubicacionempleadoraltern.hoodCompanyAlternate) {
            const ban = catalog.hoodCompanyAlternate.find(e => e.label.toUpperCase() === step3.ubicacionempleadoraltern.hoodCompanyAlternate.toUpperCase());
            if (!(ban && ban.value)) {
              valid = false;
              campo = campo + " Barrio empresa alterna, debe seleccionar uno de la lista,";
            }
          }
        }

      }

      if (step3?.ubicacionempleadorcontact) {
        campo = 'Por favor ingresar los campos requeridos: sección "Datos de ubicación" campos: (';

        if (!step3.ubicacionempleadorcontact["smartPhoneCompany"]) {
          valid = false;
          campo = campo + " Teléfono de celular,";
        }

        if (step3.ubicacionempleadorcontact["smartPhoneCompany"] && step3.ubicacionempleadorcontact["smartPhoneCompany"].length < 10) {
          valid = false;
          campo = campo + " la longitud del celular debe ser de 10 digitos,";
        }

        // if (!(step3.ubicacionempleadorcontact["phoneCompany"] && step3.ubicacionempleadorcontact["phoneCompany"].length > 0)) {
        //   valid = false;
        //   campo = campo + " el teléfono fijo es obligatorio, ";
        // }

        if (step3.ubicacionempleadorcontact["phoneCompany"] && step3.ubicacionempleadorcontact["phoneCompany"].substring(0, 2) !== "60") {

          valid = false;
          campo = campo + " el indicativo del teléfono es incorrecto,";
        }



        if (step3.ubicacionempleadorcontact["phoneCompany"] && (step3.ubicacionempleadorcontact["phoneCompany"].substring(0, 3) === "603" || step3.ubicacionempleadorcontact["phoneCompany"].substring(0, 3) === "609")) {
          valid = false;
          campo = campo + " el indicativo del teléfono es incorrecto,";
        }

        if (step3.ubicacionempleadorcontact["phoneCompany"] && step3.ubicacionempleadorcontact["phoneCompany"].length < 10) {
          valid = false;
          campo = campo + " la longitud del numero de teléfono debe ser de 10 digitos,";
        }

        if (step3.ubicacionempleadorcontact.webSite &&
          !/^(?:www\.)?(?:\w(?:[-\w]{0,61}\w)?\.)*?(\w(?:[-\w]{0,61}\w)?\.(?:\w{2,3}\.)?\w{1,10})(?:[/?#]|$)/i.test(
            step3.ubicacionempleadorcontact.webSite
          )
        ) {
          valid = false;
          campo = campo + " el formato de pagina web es incorrecto,";
        }




      } else {
        valid = false;
      }




    }

    if (va === 4) {
      if (step4?.datosrepresentante) {
        var ban2 = false;
        campo = 'Por favor ingresar los campos requeridos: sección "Información representante legal" campos: (';
        requiredStep4.forEach(element => {
          if (!step4.datosrepresentante[element.value]) {
            valid = false;
            campo = campo + " " + element.label + ",";
          }
        });

        if (step4.datosrepresentante && step4.datosrepresentante.jobBoss) {
          const ban = catalog.jobBoss.find(e => e.label.toUpperCase() === step4.datosrepresentante.jobBoss.toUpperCase());
          if (!(ban && ban.value)) {
            valid = false;
            campo = campo + " Cargo, debe seleccionar uno de la lista,";
          }
        }

        if (step4.datosrepresentante.numberId && step4.datosrepresentante.numberId === "NI" && step4.datosrepresentante.numberId.length !== 9) {
          valid = false;
          campo = `${campo}, Número de identificación longitud debe ser de 9 caracteres,`;
        }

        if (step4.datosrepresentante.numberId && (step4.datosrepresentante.numberId === "PA" || step4.datosrepresentante.numberId === "PT" || step4.datosrepresentante.numberId === "PE") && step4.datosrepresentante.numberId.length > 16) {
          valid = false;
          campo = `${campo}, Número de identificación longitud maxima 16 caracteres,`;
        }

        if (step4.datosrepresentante.numberId && step4.datosrepresentante.numberId === "CC" && step4.datosrepresentante.numberId.length < 3) {
          valid = false;
          campo = `${campo}, Número de identificación longitud minima 3 caracteres,`;
        }
        if (step4.datosrepresentante.numberId && step4.datosrepresentante.numberId === "CC" && step4.datosrepresentante.numberId.length > 10) {
          valid = false;
          campo = `${campo}, Número de identificación longitud maxima 10 caracteres,`;
        }

        if (step4.datosrepresentante.numberId && step4.datosrepresentante.numberId === "CE" && step4.datosrepresentante.numberId.length > 7) {
          valid = false;
          campo = `${campo}, Número de identificación longitud maxima de caracteres 7,`;
        }

        if (step4.datosrepresentante["smartPhoneBoss"] && step4.datosrepresentante["smartPhoneBoss"].length < 10) {
          valid = false;
          campo = campo + " la longitud del celular debe ser de 10 digitos,";
        }

        if (step4.datosrepresentante["emailJobBoss"]
          && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(step4.datosrepresentante["emailJobBoss"])
        ) {
          valid = false;
          campo = campo + " el formato de correo electrónico es incorrecto,";
        }

      } else {
        valid = false;
      }


    }

    if (valid === true)
      campo = ""
    return { valid, campo: campo };
  } catch (error) {
    console.error("Function.validateForm", error);
    throw error;
  }

}

function* validateStep1(action) {
  const { datospersonaladmin } = action

  try {
    var valid = true;
    let campo = "Por favor ingresar los campos requeridos marcados con ( * )";
    const requiredStep1 = REQUIRED_FORM_STEP1;

    if (datospersonaladmin) {
      campo = 'Por favor ingresar los campos requeridos: sección "Información personal administrativo y/o directivo" campos: (';
      requiredStep1.forEach(element => {
        if (!datospersonaladmin[element.value]) {
          valid = false;
          campo = campo + " " + element.label + ",";
        }
      });

      if (datospersonaladmin.numberIdStaff && datospersonaladmin.typeIdStaff === "NI" && datospersonaladmin.numberIdStaff.length !== 9) {
        valid = false;
        campo = `${campo}, Número de identificación longitud debe ser de 9 caracteres,`;
      }

      if (datospersonaladmin.numberIdStaff && (datospersonaladmin.typeIdStaff === "PA" || datospersonaladmin.typeIdStaff === "PT" || datospersonaladmin.typeIdStaff === "PE") && datospersonaladmin.numberIdStaff.length > 16) {
        valid = false;
        campo = `${campo}, Número de identificación longitud maxima 16 caracteres,`;
      }

      if (datospersonaladmin.numberIdStaff && datospersonaladmin.typeIdStaff === "CC" && datospersonaladmin.numberIdStaff.length < 3) {
        valid = false;
        campo = `${campo}, Número de identificación longitud minima 3 caracteres,`;
      }
      if (datospersonaladmin.numberIdStaff && datospersonaladmin.typeIdStaff === "CC" && datospersonaladmin.numberIdStaff.length > 10) {
        valid = false;
        campo = `${campo}, Número de identificación longitud maxima 10 caracteres,`;
      }

      if (datospersonaladmin.numberIdStaff && datospersonaladmin.typeIdStaff === "CE" && datospersonaladmin.numberIdStaff.length > 7) {
        valid = false;
        campo = `${campo}, Número de identificación longitud maxima de caracteres 7,`;
      }

      if (datospersonaladmin.smartPhoneBossStaff && datospersonaladmin.smartPhoneBossStaff.length !== 10) {
        valid = false;
        campo = `${campo}, Número de celular debe ser de 10 digitos,`;
      }

      if (datospersonaladmin.emailStaff &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
          datospersonaladmin.emailStaff
        )
      ) {
        valid = false;
        campo = `${campo}, Formato de correo electrónico invalido,`;
      }



    } else {
      valid = false;
    }


    return { valid, campo };
  } catch (error) {
    console.error("Function.validateStep1", error);
  }

}

function* validateStepPrincipal(action) {
  const { items } = action

  try {
    var valid = true;
    let banAll = false;
    let campo = "Por favor ingresar los campos requeridos marcados con ( * ";
    const requiredPrincipal = REQUIRED_FORM_PRINCIPAL;
    campo = "";
    if (items && items.afiliacionEmpresas) {

      campo = 'Por favor ingresar los campos requeridos: sección "formulario de afiliación de empresas" campos: (';
      requiredPrincipal.forEach(element => {
        if (!items.afiliacionEmpresas[element.value]) {
          valid = false;
          campo = campo + " " + element.label + ",";
        }
      });

      if (items.afiliacionEmpresas.numberIdCompanyGes && items.afiliacionEmpresas.typeIdCompanyGes === "NI" && items.afiliacionEmpresas.numberIdCompanyGes.length !== 9) {
        valid = false;
        campo = `${campo}, Número de identificación longitud debe ser de 9 caracteres,`;
      }

      if (items.afiliacionEmpresas.numberIdCompanyGes && (items.afiliacionEmpresas.typeIdCompanyGes === "PA" || items.afiliacionEmpresas.typeIdCompanyGes === "PT" || items.afiliacionEmpresas.typeIdCompanyGes === "PE") && items.afiliacionEmpresas.numberIdCompanyGes.length > 16) {
        valid = false;
        campo = `${campo}, Número de identificación longitud maxima 16 caracteres,`;
      }

      if (items.afiliacionEmpresas.numberIdCompanyGes && items.afiliacionEmpresas.typeIdCompanyGes === "CC" && items.afiliacionEmpresas.numberIdCompanyGes.length < 3) {
        valid = false;
        campo = `${campo}, Número de identificación longitud minima 3 caracteres,`;
      }
      if (items.afiliacionEmpresas.numberIdCompanyGes && items.afiliacionEmpresas.typeIdCompanyGes === "CC" && items.afiliacionEmpresas.numberIdCompanyGes.length > 10) {
        valid = false;
        campo = `${campo}, Número de identificación longitud maxima 10 caracteres,`;
      }

      if (items.afiliacionEmpresas.numberIdCompanyGes && items.afiliacionEmpresas.typeIdCompanyGes === "CE" && items.afiliacionEmpresas.numberIdCompanyGes.length > 7) {
        valid = false;
        campo = `${campo}, Número de identificación longitud maxima de caracteres 7,`;
      }

    } else {
      valid = false;
      banAll = true;
    }
    if (banAll)
      campo = "Por favor ingresar los campos requeridos marcados con ( * "
    return { valid, campo: `${campo} )` };
  } catch (error) {
    console.error("Function.validateStepPrincipal", error);
    throw error;
  }

}


function* validateDireccion(action) {
  const { items } = action

  try {
    var valid = true;
    let banAll = false;
    let campo = "Por favor ingresar los campos requeridos ";
    const requiredDireccion = REQUIRED_DATOS_DIRECCION;
    campo = "";
    if (items && items.datosdireccion) {

      campo = 'Por favor ingresar los campos requeridos: sección "Datos Dirección" campos: (';
      requiredDireccion.forEach(element => {
        if (!items.datosdireccion[element.value]) {
          valid = false;
          campo = campo + " " + element.label + ",";
        }
      });



    } else {
      valid = false;
      banAll = true;
    }
    if (banAll)
      campo = "Por favor ingresar todos campos requeridos"
    return { valid, campo: `${campo} )` };
  } catch (error) {
    console.error("Function.validateStepPrincipal", error);
    throw error;
  }

}

function* createDireccionModal(action) {
  //crear la dirección a partir del modal
  try {
    const dataDir = yield select(getFormValuesDireccion);
    const nameCampoDire = yield select(getNameCampoDire);

    if (dataDir && dataDir.datosdireccion) {
      const validate = yield validateDireccion({ items: dataDir })
      if (validate.valid) {
        const datosdireccion = dataDir.datosdireccion;
        let newDir = ""
        if (datosdireccion.interseptionType === "CORR")
          newDir = `${emptyObject(datosdireccion.interseptionType)} ${emptyObject(datosdireccion.interseptionNumber)} ${emptyObject(datosdireccion.houseTypeCor)} ${emptyObject(datosdireccion.houseComplemento)}`;
        else
          newDir = `${emptyObject(datosdireccion.interseptionType)} ${emptyObject(datosdireccion.interseptionNumber)} ${emptyObject(datosdireccion.interseptionNumberTwo)} ${emptyObject(datosdireccion.interseptionNumberThree)} ${emptyObject(datosdireccion.houseType)} ${emptyObject(datosdireccion.houseComplemento)}`;
        if (nameCampoDire.includes("addressCompanyAltenate"))
          yield put(change(FORM_NAME_STEP3, nameCampoDire, cortarMSM(newDir, 50)));
        else
          yield put(change(FORM_NAME_STEP3, nameCampoDire, cortarMSM(newDir, 50)));
        yield put(changeCorregimientoForm(false));
        yield put(closeDireccionModalSuccess())
      } else {
        yield put(modalInformacionFlujos(
          {
            message: validate.campo,
            error: true,
            open: true,
          }));
      }
    } else {
      yield put(modalInformacionFlujos(
        {
          message: "Debe diligenciar los campos requeridos para una dirección valida",
          error: true,
          open: true,
        }));
    }


  } catch (error) {
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* createCatalog() {

  const catalog = "CARGOS"
  const datos = yield migrarCatalogo({ catalog: catalog })
  console.log(datos)
  // const datos = [
  //   { value: "msgRegiDownloadNotBD", type: "bandeja", label: "La afiliación que intenta descargar no se encontro en base de datos, por favor inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2" },
  //   { value: "msgNotPermitAccessUser", type: "bandeja", label: "El usuario no cuenta con los permisos necesarios para acceder a la informacion de la bandeja." },
  //   { value: "msgDevolCmrSuccess", type: "bandeja", label: "El proceso de devolución a comercial ha terminado exitosamente." },
  //   { value: "msgDevolCmrFailure", type: "bandeja", label: "No se pudo realizar el proceso de devolución a comercial correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
  //   { value: "msgAfiliaSuccess", type: "bandeja", label: "El proceso de afiliación ha terminado exitosamente, la empresa fue afiliada con al siguiente informacion:" },
  //   { value: "msgAfiliaFailure", type: "bandeja", label: "No se pudo realizar el proceso de afiliación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
  //   { value: "msgDevolSuccess", type: "bandeja", label: "El proceso de devolución ha terminado exitosamente." },
  //   { value: "msgDevolFailure", type: "bandeja", label: "No se pudo realizar el proceso de devolucion correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
  //   { value: "msgAnulaSuccess", type: "bandeja", label: "El proceso de anulación ha terminado exitosamente." },
  //   { value: "msgAnulaFailure", type: "bandeja", label: "No se pudo realizar el proceso de anulación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente" },
  //   { value: "msgAprobacionSuccess", type: "bandeja", label: "El proceso de aprobación ha terminado exitosamente." },
  //   { value: "msgAprobacionFailure", type: "bandeja", label: "No se pudo realizar el proceso de aprobación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente" },

  //   { value: "msgSolicitudEnProceso", type: "company", label: "Hemos encontrado una solicitud de afiliación con los datos ingresados la cual se encuentra en proceso de validación por el área correspondiente. Si su proceso de afiliación lleva más de 1 día hábil por favor comuníquese a la línea de Servicio al Cliente 602 8862727 opción 2." },
  //   { value: "msgNumeroCCErrado", type: "company", label: "El número de documento ingresado no arroja resultados o esta errado, por favor verifique la información e inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
  //   { value: "msgSerAniNoDisponible", type: "company", label: "El servicio de validación de información de la registraría nacional no se encuentra disponible, por favor ingrese la información como aparece en su documento de identificación personal. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
  //   { value: "msgEmpresaRegistradaSirapInactiva", type: "company", label: "La informaciòn ingresada nos arroja que la empresa ya se encuentra registrada en nuestra base de datos y se encuentra en estado inactivo. Por favor comuníquese con nuestra línea de servicio al cliente 602 8862727 opción 2.El servicio de validación de información de la registraría nacional no se encuentra disponible, por favor ingrese la información como aparece en su documento de identificación personal. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
  //   { value: "msgEmpresaRegistradaSirapActiva", type: "company", label: "La información ingresada nos arroja que la empresa ya tiene un registro en nuestra base de datos. Por favor comuníquese con nuestra línea de servicio al cliente 602 8862727 opción 2." },
  //   { value: "msgValidaAniSuccess", type: "company", label: "Sus datos de identificación fueron validados por medio de la Registraduria Nacional." },
  //   { value: "msgMaximoRegistraContactos", type: "company", label: "El máximo de personas que se pueden registrar con 3, si deseas agregar a alguien diferente debes eliminar uno de la lista." },
  //   { value: "msgAnexoDuplicadoMismaInfo", type: "company", label: "Hemos encontrado en la solicitud un anexo que contiene la misma información que el archivo que intenta adjuntar. Por favor verifique la información e inténtenlo nuevamente." },
  //   { value: "msgAnexoNoCumpleCondiciones", type: "company", label: "El archivo que intenta adjuntar no cumple con las condiciones permitidas para esta afiliación." },
  //   { value: "msgOportunidadIncorrectoOpenForm", type: "company", label: "El valor ingresado no coincide con el que tiene registrado, por favor verifique la información e intentelo nuevamente." },
  //   { value: "msgConsultaEmpresasNoDisponible", type: "company", label: "La operación solicitada no pudo completarse, intentalo nuevamente en unos segundos." },
  //   { value: "msgGeneralServicioNoDisponible", type: "company", label: "Ocurrió una respuesta inesperada al momento de registrar su información, por favor inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
  //   { value: "msgPdfAdobeSuccesReenvio", type: "company", label: "El registro de su empresa ha terminado exitosamente y será evaluado por el área correspondiente. Si la documentación es aprobada, en el siguiente día hábil (1) quedará afiliado(a), de lo contrario le informaremos a su correo electrónico." },
  //   { value: "msgPdfAdobeFirmaSucces", type: "company", label: "El registro de su empresa ha terminado exitosamente. Hemos enviado a su correo electrónico el formulario de afiliación para su firma electrónica. Una vez sea firmado el documento y aprobado por el área correspondiente, en el siguiente día hábil (1) su empresa quedará activa y podrá realizar la afiliación de sus colaboradores, de lo contrario recibirá una notificación." },

  // ]
  try {
    // yield datos.map(e => {
    //   let i = {}
    //   i.label = `${e.CODIGO_LEY} - ${primeraMayuscula(e.DESCRIPCION.toLowerCase())}`;
    //   i.value = e.ID_CLEC;
    //   i.codigoley = e.CODIGO_LEY;
    //   i.id_ticl = e.ID_TICL;
    //   i.id_clec_padre = e.ID_CLEC_PADRE;
    //   firebaseDatabase.collection(`catalogos/CLASIFICACIONES_ECONOMICAS/data`).add(i);
    // });
    yield datos.data.map(e => {
      //e.label = primeraMayuscula(e.label.toLowerCase());
      firebaseDatabase.collection(`catalogos/${catalog}/data`).add(e);
    });

  } catch (error) {
    console.error(error);
  }
}

function* createConversion() {

  let jsonToExcel = [];

  yield firebaseDatabase.collection("solicitudesEmpresas")
    .where('state', 'in', [estados.AFILIADA,estados.ANULADA,estados.FIRMADA])
    .get().then(docs => {
      docs.forEach(doc => {
        if (doc.data()) {
          const d = doc.data()
          jsonToExcel.push({
            typeDocumento: d.step0.datosinicio.typeIdCompanyStart,
            documentoId: d.step0.datosinicio.checkNumberStart,
            razon: d.step0.datosinicio.employerNameStart,
            typeDocumentoRep: d.step4.datosrepresentante.typeId,
            documentoIdRep: d.step4.datosrepresentante.numberId,
            nameRep: `${d.step4.datosrepresentante.firstName} ${d.step4.datosrepresentante.secondName} ${d.step4.datosrepresentante.firstLastname} ${d.step4.datosrepresentante.secondLastname}`,
            cellphoneRep: d.step4.datosrepresentante.smartPhoneBoss,
            emailRep: d.step4.datosrepresentante.emailJobBoss,
            estado:d.state
          })
        }
      });
    });

  if (jsonToExcel) {

    console.log(jsonToExcel)
    try {

      let header = [
        "Tipo de documento empresa",
        "Documento empresa",
        "Razon social",
        "Tipo de documento representante",
        "Documento representante",
        "Nombre representante",
        "Celular representante",
        "Correo representante",
        "Estado afiliacion"
      ];
      
      

      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const sheetData = getSheetData(jsonToExcel, header);
        const totalColumns = 26//sheetData[0].length;                
        sheet1.cell("A1").value(sheetData);
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);
        sheet1.row(1).style("bold", true);
        sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
        range.style("border", true);

        return workbook.outputAsync().then((res) => {
          saveAs(res, "ReportsInscripcionesEmpresas.xlsx");
        });
      }).catch((err) => {
        throw err;
      })

    } catch (error) {
      console.error(error);
    }
  }
}

function getSheetData(data, header) {
  /*
función que realiza el mapeo de la información para crear el archivo excel
*/
  try {

      var fields = Object.keys(data[0]);
      var sheetData = data.map(function (row) {
          return fields.map(function (fieldName) {
              return row[fieldName] ? row[fieldName] : "";
          });
      });
      sheetData.unshift(header);
      return sheetData;
  } catch (error) {
      throw error;
  }
}

function* uploadAnexo(action) {
  /*
función que se encarga de cargar un anexo en el storage y agrega su referencia para la posterior manipulación del mismo
*/

  const { value: { row, event: { files }, rya } } = action;
  //console.log(action)
  try {
    yield put(uploadAnexosSaga({ row, charged: "chargedFileProsses", event: false }));
    yield put(openModalCharged(true));

    const nameDoc = row[0].label;
    const val = row[0].value;

    let newName = files[0].name.split(".");
    const nameFile = `${fontSizeCortar(newName[0])}.${newName[newName.length - 1]}`;

    const archivo = files[0];
    const idFile = archivo.lastModified;
    const typeFile = archivo.type;
    const allowedFiles = [
      "pdf", "jpg", "png", "jpeg", "gif", "BMP"
    ]
    const tamanioFiles = yield select(getTamanioFiles);

    if (archivo.size <= tamanioFiles) {

      let infoUser = yield select(getUserInfoComercial);
      if (!infoUser)
        infoUser = yield select(getUserPersona);

      const allowed = allowedFiles.find(allowedFile => typeFile.toLowerCase().includes(allowedFile.toLowerCase()))
      if (archivo && allowed !== undefined) {
        var base = yield select(getbase64Add);
        let mismoFile = false;
        //console.log(base)
        if (rya) {
          if (base && base.length > 0)
            base = base.filter(files => files.campo !== val);
        } else {
          if (base && base.length > 0)
            mismoFile = base.find(files => files.idFile === idFile);
        }

        if (mismoFile !== undefined && mismoFile.idFile) {
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(openModalCharged(false))
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgAnexoDuplicadoMismaInfo"),
              error: true,
              open: true,
            }));

          yield sleep(1000)
          yield put(uploadAnexosSaga({ row, charged: false, event: false }));

        } else {
          const res = yield getBase64(archivo);

          const aux = res.split(",")
          //console.log(aux[0]);
          //var base = yield select(getbase64Add)
          const temBase = base;
          // base.forEach(element => {
          //   //verificar si ya hay un archivo similar guardado
          //   if (element.idFile !== idFile) {
          //     temBase.push(element)
          //   }
          // });
          const temp = {
            name: nameDoc,
            nameDoc: nameDoc,
            campo: val,
            idFile,
            doc: {
              contenidoArchivo: aux[1],
              extensionArchivo: typeFile,
              nombreArchivo: nameFile,
            }
          }
          temBase.push(temp)
          yield put(saveAnexos({ start: false, data: temBase }))


          var refeFiles = yield select(getRefeFiles);
          const idFormulario = yield select(getIdFormulario);

          const refFil = `${idFormulario}/${val}/${nameFile}`;
          const catalogo = yield select(getCatalogosCargados);
          if (rya) {
            let auxRefeFiles = [];
            let deleteRef = "";
            if (refeFiles.length > 0)
              auxRefeFiles = refeFiles.filter(e => e.refFile.split("/")[1] !== val)

            const fireStorageRef = firebaseStorage.ref();
            const fileReference = fireStorageRef.child(refFil);
            yield performOperationWithRetry(fileReference, archivo, catalogo)
              .then(result => {
                console.log('Operación exitosa:', result);
              })
              .catch(error => {
                console.error('Operación fallida:', error);
                throw error;
              });

            auxRefeFiles.push({
              size: archivo.size,
              nameArchivo: nameFile,
              lastModified: archivo.lastModified,
              nameDoc,
              type: archivo.type,
              refFile: refFil,
            });
            yield put(saveRefeFiles([...auxRefeFiles]));

            const history = {
              fechaHistory: new Date(),
              tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
              infoUsuario: infoUser,
              resultadoValidacion: {
                accionRealizada: deleteRef ? "Reemplazar anexo" : "Carga nuevo anexo",
                observacion: `Se anexó un nuevo archivo con nombre : ${nameFile}, en el campo: ${nameDoc}`,
                refFil
              }
            }

            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ refeFiles: auxRefeFiles, date: history.fechaHistory }, { merge: true });
            saveHistoryEmpresas({ history, idFormulario });

            if (deleteRef) {
              const fireStorageRefDel = firebaseStorage.ref();
              const fileReferenceDel = fireStorageRefDel.child(deleteRef);
              yield fileReferenceDel.delete().then(() => {// File deleted successfully
              }).catch((error) => {              // Uh-oh, an error occurred!
              });
            }



          } else {
            let exist = false;
            if (refeFiles.length > 0)
              refeFiles.forEach(e => {
                if (e.refFile === refFil) exist = true;
              });
            if (!exist) {

              const fireStorageRef = firebaseStorage.ref();
              const fileReference = fireStorageRef.child(refFil);

              yield performOperationWithRetry(fileReference, archivo, catalogo)
                .then(result => {
                  console.log('Operación exitosa:', result);
                })
                .catch(error => {
                  console.error('Operación fallida:', error);
                  throw error;
                });

              refeFiles.push({
                size: archivo.size,
                nameArchivo: nameFile,
                lastModified: archivo.lastModified,
                nameDoc,
                type: archivo.type,
                refFile: refFil,
              });

              const history = {
                fechaHistory: new Date(),
                tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
                infoUsuario: infoUser,
                resultadoValidacion: {
                  accionRealizada: "Adjuntar anexo",
                  observacion: `Se anexó un nuevo archivo con nombre : ${nameFile}, en el campo: ${nameDoc}`,
                  refFil
                }
              }

              yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).set({ refeFiles: refeFiles, date: history.fechaHistory }, { merge: true });
              yield put(saveRefeFiles(refeFiles));


              saveHistoryEmpresas({ history, idFormulario });
            }
          }

          yield put(uploadAnexosSaga(action.value));
        }
      } else {

        const msgParametrizados = yield select(getMsgParametrizados);
        yield put(openModalCharged(false));
        yield put(modalInformacionFlujos(
          {
            message: yield generateMsgParametrizado(msgParametrizados, "msgAnexoNoCumpleCondiciones"),
            error: true,
            open: true,
          }));
        yield sleep(1000);
        yield put(uploadAnexosSaga({ row, charged: false, event: false }));
      }
    } else {
      yield put(openModalCharged(false));
      yield put(modalInformacionFlujos(
        {
          message: `El archivo que intenta adjuntar supera el maximo tamaño permitido para esta afiliación. el tamaño maximo es de ${tamanioFiles / 1000000}MB`,
          error: true,
          open: true,
          row
        }));
      yield sleep(1000)
      yield put(uploadAnexosSaga({ row, charged: false, event: false }));

    }


    yield put(openModalCharged(false))
  } catch (error) {
    console.error(error);
    yield put(uploadAnexosSaga({ row, charged: false, event: false }));
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function performOperationWithRetry(fileReference, archivo, catalogo) {

  const maxRetryAttempts = 1; // Número máximo de reintentos
  const config = catalogo.configForm?.find(e => e.label === "timeOutUploadFile")
  const retryDelay = config && config.value ? config.value : 60000; // Tiempo de espera entre reintentos en milisegundos

  let retryCount = 0;

  return new Promise((resolve, reject) => {
    const performOperation = () => {
      const uploadTask = fileReference.put(archivo);

      uploadTask.on('state_changed', (snapshot) => {
        // Monitorizar el progreso de la carga si es necesario
        //console.log("subiendo..")

      }, (error) => {
        reject('Operación fallida después de múltiples intentos');
        // Manejar errores aquí, puedes implementar lógica de reintento personalizada si es necesario
      }, () => {
        // La carga se completó con éxito
        resolve("operacion terminada")
      });
      if (retryCount < maxRetryAttempts) {
        retryCount++;
        setTimeout(performOperation, retryDelay);
      } else {
        uploadTask.cancel();
        reject('Network Error - Operación fallida después de múltiples intentos');
      }
    };

    performOperation();
  });
}




function* removeAnexo(action) {
  /*
función que se encarga de eliminar un anexo de la postulación y toda la información que lo relaciona
*/
  try {
    const { value: { row } } = action;
    const val = row[0].value;
    const base = yield select(getbase64Add);
    const idFormulario = yield select(getIdFormulario);

    const temBase = []
    let file = base.find(e => e.campo === val);
    if (file) {
      base.forEach(element => {
        //verificar si ya hay un archivo similar guardado
        if (element.campo !== val) {
          temBase.push(element)
        }
      });
      yield put(saveAnexos({ start: false, data: [...temBase] }));

      const tempRef = []
      const refeFiles = yield select(getRefeFiles);

      refeFiles.forEach(e => {
        if (e.lastModified !== file.idFile) {
          tempRef.push(e)
        }
      });

      yield put(saveRefeFiles([...tempRef]));



      let infoUser = yield select(getUserInfoComercial);
      if (!infoUser)
        infoUser = yield select(getUserPersona);

      const refeFile = refeFiles.find(e => e.lastModified = file.idFile)

      const history = {
        fechaHistory: new Date(),
        tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
        infoUsuario: infoUser,
        resultadoValidacion: {
          accionRealizada: "Eliminar anexo",
          observacion: `Se borro un anexó de la postulación con nombre : ${refeFile.nameArchivo}, en el campo: ${refeFile.nameDoc}`,
          refFil: refeFile.refFile
        }
      }

      yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
        .doc(idFormulario).set({ refeFiles: tempRef, date: history.fechaHistory }, { merge: true });

      saveHistoryEmpresas({ history, idFormulario });
    }
  } catch (error) {
    console.error(error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* seeAnexo(action) {
  /*
función que se encarga de abrir el modal con el anexo solicitado
*/
  try {
    const { value: { row } } = action;

    const refFiles = yield select(getRefeFiles);

    const temSee = refFiles.find(e => e.nameDoc === row[0].label && e.refFile.split("/")[1] === row[0].value)

    if (temSee)
      yield put(popupSEEAnexos({ open: true, file: temSee }))
    //imprimir el archivo
  } catch (error) {
    console.error(error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* validateNumProcess(action) {
  /*
función que valida el numero de proceso registrado en una afiliación respecto al ingresado por el usuario
*/
  try {
    const newIdForm = yield select(getFormValuesModalIdForm)

    var idFormulario = yield select(getIdFormulario);
    const solicitudes = yield select(getSolicitudes);
    if (newIdForm && newIdForm.datosNumProcess && newIdForm.datosNumProcess.processNumber) {
      //validamos si el id de oportunidad corresponde con el ingresado por el usuario
      if (newIdForm.datosNumProcess.processNumber === solicitudes.idOportunidad) {
        yield put(openModalNumProcess(false));
        yield put(estadoAfiliacionCompany(true));

        if (solicitudes.devolucion && solicitudes.devolucion.motivo) {
          let datadevolucion = solicitudes.devolucion;
          datadevolucion.encabezado = "Sr. Usuario, recuerde que su solicitud de afiliación fue evaluada por el área correspondiente y ha sido devuelta, por favor realice las correcciones necesarias y continúe con el proceso:";
          yield put(verMotivoDevolucion({ open: true, datadevolucion }))
        }
        yield initAllForms({ value: solicitudes });
        let infoUser = yield select(getUserInfoComercial);
        if (!infoUser)
          infoUser = yield select(getUserPersona);
        const history = {
          fechaHistory: new Date(),
          tomado: `${emptyObject(infoUser.rol)}  ${emptyObject(infoUser.nameCompleted)}`,
          infoUsuario: infoUser,
          resultadoValidacion: {
            accionRealizada: "Retomar",
            observacion: "Accesa nuevamente al formulario"
          },
        }
        saveHistoryEmpresas({ history, idFormulario })
      } else {
        yield put(openModalNumProcess(false));
        const msgParametrizados = yield select(getMsgParametrizados);
        yield put(modalInformacionFlujos(
          {
            message: yield generateMsgParametrizado(msgParametrizados, "msgOportunidadIncorrectoOpenForm"),
            error: true,
            open: true,
          }));
      }
    } else {
      yield put(openModalNumProcess(false));
      yield put(modalInformacionFlujos(
        {
          message: "El campo Numero de proceso no puede estar vacio, por favor ingrese la información solicitada",
          error: true,
          open: true,
        }));
    }


  } catch (error) {
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* submitSalveStep(action) {

  const { value: { formFiles, final, aceptaTerminos } } = action;
  try {
    var file = false;
    var banDel = false;
    if (aceptaTerminos) {
      yield put(openModalCharged(true));



      if (!final)
        yield put(modalInformacionFlujos(
          {
            message: "Guardado con exito!",
            error: false,
            open: true,
          }));
      yield saveEraser({ final: true });
    } else {
      yield put(closeFinalModal())
      yield put(modalInformacionFlujos(
        {
          message: "Debe aceptar terminos y condiciones para poder continuar con el registro de la solicitud",
          error: true,
          open: true,
        }));
    }
  } catch (error) {
    console.error(error)
    yield put(errorGeneral(manejoDeexepciones(error)));
  }

}

function* validateAnexos(action) {
  /*
función que valida si los anexos marcados como obligatorios ha sido anexados
*/
  try {
    const refeFiles = yield select(getRefeFiles);
    const dynamicOptions = yield select(getDynamicOptions);
    const anexos = dynamicOptions.tableOfAnexos;
    let faltaAnexo = false;
    if (refeFiles.length > 0) {
      anexos.forEach(e => {
        if (e[1].label === "SI") {
          let exist = false;
          refeFiles.forEach(i => {
            let cod = i.refFile.split("/")
            if (cod[1] === e[0].value)
              exist = true;
          });
          if (!exist) {
            //falta anexo
            faltaAnexo = true;
          }
        }
      });

    } else {
      faltaAnexo = true;
    }

    if (faltaAnexo) {
      yield put(modalInformacionFlujos(
        {
          message: "Debe realizar la carga de todos los anexos definidos como obligatorios para poder continuar",
          error: true,
          open: true,
        }));
    } else {
      yield put(openModalCharged(true));
      const idFormulario = yield select(getIdFormulario);
      const base64File = yield pdfgenera({ idFormulario })

      if (base64File) {
        yield put(openModalAcceptPDF({
          open: true,
          data: base64File,
          type: "application/pdf"
        }))

      }
      else {
        yield put(modalInformacionFlujos(
          {
            message: "Ocurrió un error inesperado al procesar la información del formulario, por favor inténtenlo más tarde.",
            error: true,
            open: true,
          }));
      }
    }
    yield put(openModalCharged(false));
  } catch (error) {
    console.error(error)
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* validateChanges(action) {
  try {
    const { value } = action;
    const type = value.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany;

    yield put(chagesFromBandeja());
    let itemsStep = yield select(getFormValuesStep2);
    const empleador = value.step2.datosempleador;


    if (!itemsStep.datosempleador.employedNumber) {
      itemsStep.datosempleador.employedNumber = empleador.employedNumber;
    }
    if (!itemsStep.datosempleador.payrollMonth) {

      itemsStep.datosempleador.payrollMonth = empleador.payrollMonth;
    }

    if (type === "1") {
      if (!itemsStep.datosempleador.startOperation) {
        itemsStep.datosempleador.startOperation = empleador.startOperation;
      }
    }

    yield put(initialize(FORM_NAME_STEP2, itemsStep));


  } catch (error) {
    console.error(error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* deleteContactFromValid(action) {
  /*
función que realiza las acciones correspondientes a la información de contacto de la afiliacion, limpia, eliminar o agregar 
*/
  const { value: { name, data } } = action;
  // console.log("", action)
  try {
    if (name === "aceptar") {
      let tablePersonal = yield select(getTableDataPersonal);
      let newData = {
        disable: false,
        options: [],
        field: "tablePersonal",
      };
      let tableNew = []
      tablePersonal.forEach(items => {
        if (!(items.numberIdStaff === data.id && items.typeIdStaff === data.type)) {
          newData.options.push([
            { label: emptyObject(items.typeIdStaff) },
            { label: emptyObject(items.numberIdStaff) },
            { label: emptyObject(items.firstLastnameStaff) },
            { label: emptyObject(items.secondLastnameStaff) },
            { label: emptyObject(items.firstNameStaff) },
            { label: emptyObject(items.secondNameStaff) },
            { label: emptyObject(items.jobBossStaff) },
            { label: emptyObject(items.emailStaff) },
          ]);
          tableNew.push(items);
        }

      });
      yield put(loadDocumentSuccess(newData));
      yield put(saveDataTablePersonal(tableNew));
      const step4 = yield select(getFormValuesStep4);
      if (step4.datosrepresentante.typeId === "CC") {
        yield put(openModalCharged(true));

        const resReg = yield consultaAndLockPersonal({ id: step4.datosrepresentante.numberId, tipo: "CC", nuevo: true, type: "repLegal" });
        yield put(openModalCharged(false))

        if (!resReg) {
          //Procesar mensaje dependiento si la empresa esta activa o no 
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgNumeroCCErrado"),
              error: true,
              open: true,
            }));

          yield put(callDinamicDisableLote([
            { field: "birthDate", state: true },
            { field: "firstLastname", state: true },
            { field: "secondLastname", state: true },
            { field: "firstName", state: true },
            { field: "secondName", state: true },
            { field: "sexo", state: true },
            { field: "jobBoss", state: true },
            { field: "smartPhoneBoss", state: true },
            { field: "emailJobBoss", state: true }
          ]));

        } else if (resReg.servicioAbajo) {
          const msgParametrizados = yield select(getMsgParametrizados);
          yield put(modalInformacionFlujos(
            {
              message: yield generateMsgParametrizado(msgParametrizados, "msgSerAniNoDisponible"),
              error: true,
              open: true,
            }));

          yield put(callDinamicDisableLote([
            { field: "birthDate", state: false },
            { field: "firstLastname", state: false },
            { field: "secondLastname", state: false },
            { field: "firstName", state: false },
            { field: "secondName", state: false },
            { field: "sexo", state: false },
            { field: "jobBoss", state: false },
            { field: "smartPhoneBoss", state: false },
            { field: "emailJobBoss", state: false }
          ]));

        }

      }
    }
    if (name === "cancelar") {
      yield put(change(FORM_NAME_STEP4, "datosrepresentante.numberId", ""))
      //console.log("Ingresa nueva persona")
    }
  } catch (error) {
    console.error(`deleteContactFromValid - saja.js : ${error}`);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}

function* downloadRelationWorkers(action) {
  try {
    const { value } = action;
    const catalogo = yield select(getCatalogosCargados);

    let solicitudes = yield select(getSolicitudesSinfirma);
    if (solicitudes)
      solicitudes.step1.datospersonaladmin = yield select(getTableDataPersonal);
    else
      solicitudes = yield select(getSolicitudes);
    let direccion = yield returnDataCatalogV2(catalogo.sedes, solicitudes.step0.datosinicio.sedeRegional, "value", "label")
    const resul = yield pdf(<MyDocumentRelacion data={{ ...solicitudes }} direccion={direccion} />).toBlob();
    let aux = []
    if (resul) {
      const res = yield getBase64(resul)
      aux = res.split(",")[1]
      generatePDFbUtil(aux);
    }

  } catch (error) {
    console.error(error);
    yield put(errorGeneral(manejoDeexepciones(error)));
  }
}


export function* watchUsers() {

  yield takeLatest(LOAD_CATALOG, buildDynamicOptions);
  yield takeLatest(REDUX_BLUR, onreduxBlur);
  yield takeLatest(INCREASE_STEP, saveEraser);
  yield takeLatest(REDUX_CHANGE, onReduxChange);
  yield takeLatest(VALIDA_AFILIACION_COMPANY, validaAfiliacionCompany);
  yield takeLatest(GESTION_PERSONAL_ADMIN, gestionPersonalAdmin);
  yield takeLatest(CREATE_DIRECCION_MODAL, createDireccionModal)
  yield takeLatest(UPLOAD_ANEXOS, uploadAnexo);
  yield takeLatest(REMOVE_ANEXOS, removeAnexo);
  yield takeLatest(SEE_ANEXOS, seeAnexo);
  yield takeLatest(VALIDATE_NUM_PROCESS, validateNumProcess);
  yield takeLatest(SALVAR_STEP, submitSalveStep);
  yield takeLatest(OPEN_VALIDATE_ANEXOS, validateAnexos);
  yield takeLatest(INIT_CATALOG_COMPLETED, continuaDowload)
  yield takeLatest(VEFICATED_CHANGES_FROM_BANDEJA, validateChanges);
  yield takeLatest(HANDLE_STEP, gestionPersonalAdmin);
  yield takeLatest(HANDLE_STEP, validateChangesFromBandeja);
  yield takeLatest(DELETE_CONTACTO_EXISTS_STEP4, deleteContactFromValid)
  yield takeLatest(DOWNLOAD_RELATION_WORKERS, downloadRelationWorkers)
}
